// NAJA framework
document.addEventListener( 'DOMContentLoaded', naja.initialize.bind( naja ) );

// Apple Pay: platba funguje jen v Safari na Apple zařízeních. Dlaždice je v CSS skrytá (fail-closed),
// tady ji odemkneme jen když prohlížeč Apple Pay opravdu umí. Třída na <body> přežije naja re-render seznamu plateb.
( function () {
	try {
		if ( window.ApplePaySession && ApplePaySession.canMakePayments() ) {
			( document.body || document.documentElement ).classList.add( 'applepay-available' );
		}
	} catch ( e ) {}
} )();

// vizuální „ukládám" stav kroku dopravy — bez něj lidé klikali znovu a rušili tím probíhající request (naja abort)
function deliverySaving( on ) {
	var form = document.querySelector( '#basket-delivery-form' );
	if ( form ) form.classList.toggle( 'is-saving', on );
}
naja.addEventListener( 'complete', function() { deliverySaving( false ); } );

naja.addEventListener( 'success', function( event ) {
	var updatingTargito = false;

	if ( typeof event.detail.payload.update_summary != 'undefined' ) {
		$( '.minicart-price' ).html( event.detail.payload.update_summary.price_formatted );
		$( '#minicart-amount-1' ).text( event.detail.payload.update_summary.items_count ).show();
		$( '#minicart-amount-2' ).text( '(' + event.detail.payload.update_summary.items_count + ')' ).show();

		// minikošík – ne každý success payload obsahuje minicart (např. jiná Naja akce) → guard proti čtení .html z undefined
		if ( typeof event.detail.payload.minicart != 'undefined' ) {
			$( '.minicart-free-shipping-html' ).html( event.detail.payload.minicart.html );
			$( '.minicart-free-shipping-percent' ).css( 'left', event.detail.payload.minicart.free_shipping_percent + '%' );

			if ( event.detail.payload.minicart.free_shipping )
			{
				$( '.minicart-free-shipping-line' ).addClass( 'hidden' );
			}
			else
			{
				$( '.minicart-free-shipping-line' ).removeClass( 'hidden' );
			}
		}

		targitoBasket();
		updatingTargito = true;
	}

	if ( typeof event.detail.payload.update_basket_items != 'undefined' ) {
		window.basket_items = event.detail.payload.update_basket_items;
		minicart_update();
		minicartMobile();

		// agregační množstevní sleva – aktualizace stavu košíku pro PDP banner
		if ( typeof event.detail.payload.aggregate_progress != 'undefined' ) {
			window.aggregate_progress = event.detail.payload.aggregate_progress;
			document.dispatchEvent( new CustomEvent( 'aggregate:updated' ) );
		}

		if ( updatingTargito === false )
		{
			targitoBasket();
		}

		if ( typeof event.detail.payload.snippets['snippet--basket-free-delivery'] != 'undefined' ) {
			if ( event.detail.payload.snippets['snippet--basket-free-delivery'].length < 10 ) {
				$( '.minicart-delivery, .minicart-delivery-wrapper' ).addClass( 'hidden' );
			} else {
				$( '.minicart-delivery' ).html( event.detail.payload.snippets['snippet--basket-free-delivery'] ).removeClass( 'hidden' );
				$( '.minicart-delivery-wrapper' ).removeClass( 'hidden' );
			}
		}
	}
} );

naja.snippetHandler.addEventListener( 'afterUpdate', function( event ) {

	// přepnutí dopravy/platby → bliknout souhrnem, ať je změna celkové ceny vidět
	if ( event.detail.snippet.id == 'snippet--basket-delivery' ) {
		var recap = document.querySelector( '.js-order-recap' );
		if ( recap ) {
			recap.classList.remove( 'order-recap--flash' );
			void recap.offsetWidth; // restart animace
			recap.classList.add( 'order-recap--flash' );
		}
	}

	console.log( event.detail.snippet.id );

    if ( event.detail.snippet.id == 'snippet--basket-delivery' ) {
		deliveryChoose();
		payChoose();
		countryChoose();
		bagChoose();
		radioFix();

		$( '.delivery-error' ).text( '' ).hide();

		//defaultValues.country = $( '.packeta-selector-open' ).data( 'country' );
		//bindOpenWidgetElements();
    }

	if ( event.detail.snippet.id == 'snippet--basket' ) {
		inputEvents();
		couponEvents();
		minicartMobile();
		fixedcart();
		targitoBasket();

		if ( $( '#snippet--basket-items table tr td a.ic_remove' ).length == 0 ) {
			location.reload();
		}
	}

	if ( event.detail.snippet.id == 'snippet--products' ) {
		inputEvents();
		addToCartEvents();
		ajaxSort();
		newsAndSaleActive();
		mobileSort();
		$( '.filter_m .btn_m' ).shake( 200, 5 );
	}

	if ( event.detail.snippet.id == 'snippet--category-filter' || event.detail.snippet.id == 'snippet--category-filter-mobile' ) {
		checkboxes();
		collapsibleFilters();
		window.setTimeout( function() {
			checkboxes();
		}, 150 );
	}

	if ( event.detail.snippet.id == 'snippet--order-form-errors' ) {
		$( 'html, body' ).animate( { scrollTop: 0 }, 60 );
	}

	if ( event.detail.snippet.id == 'snippet-search-search-whisperer' ) {
		clickableRow();
	}

	if ( event.detail.snippet.id == 'snippet-productSearch-product-search-whisperer' ) {
		productsClickableRow();
	}

	if ( event.detail.snippet.id.indexOf( 'snippet-favorites-productFavorites' ) > -1 ) {
		addToFavoritesHandler();
	}

	lazyload();

	$.LoadingOverlay( 'hide' );
});

// Dlouhé skupiny filtru (typ látky, vzor): ukázat prvních N, zbytek za „Zobrazit další (X)". Skupina se zaškrtnutou
// skrytou možností zůstane rozbalená. Volá se při načtení i po překreslení snippetů filtru (naja).
function collapsibleFilters() {
	$( '.js-collapsible' ).each( function() {
		var box = $( this );
		if ( box.data( 'collapsible-init' ) ) return;
		var n = parseInt( box.data( 'collapse' ), 10 ) || 6;
		var labels = box.children( 'label' );
		if ( labels.length <= n + 1 ) return;
		box.data( 'collapsible-init', true );
		var hidden = labels.slice( n );
		if ( hidden.find( 'input:checked' ).length ) return;
		var more = $( '<button type="button" class="filter-more"></button>' );
		function render( collapsed ) {
			hidden.toggleClass( 'is-collapsed', collapsed );
			more.text( collapsed ? box.data( 'more' ) + ' (' + hidden.length + ')' : box.data( 'less' ) );
		}
		more.on( 'click', function() { render( !hidden.first().hasClass( 'is-collapsed' ) ); } );
		box.append( more );
		render( true );
	} );
}
$( function() { collapsibleFilters(); } );

// čipy aktivních filtrů — kliknutí na čip odebere právě ten jeden filtr (Fáze 0 vylepšení filtrů)
$( document ).on( 'click', '.js-remove-filter', function() {
	var name = $( this ).data( 'name' );
	var value = String( $( this ).data( 'value' ) );

	// cena: vrátit slider i vstupy na celý rozsah (vstupy ceny jdou do URL vždy, čip se ukazuje jen při zúžení)
	if ( name === 'price' ) {
		var min = $( this ).data( 'min' ), max = $( this ).data( 'max' );
		$( '.js-input-from' ).val( min );
		$( '.js-input-to' ).val( max );
		$( '.js-range-slider' ).each( function() {
			var s = $( this ).data( 'ionRangeSlider' );
			if ( s ) s.update( { from: min, to: max } );
		} );
		$( '.category-filter' ).first().submit();
		return;
	}
	// odškrtnout odpovídající input ve VŠECH filtr formulářích (desktop i mobil) – pak přestane být v URL
	$( 'input[name="filters[' + name + '][]"][value="' + value + '"], input[name="filters[' + name + ']"][value="' + value + '"]' ).prop( 'checked', false );
	// odeslat filtr (filters.js zařídí AJAX + překreslení výpisu i čipů)
	$( '.category-filter' ).first().submit();
} );

// Heureka badge / Více o produktu → scroll na sekci.
// POZOR: na desktopu NEscrolluje window, ale vnitřní kontejner .page (viz jquery.js) → nutno scrollovat
// ten správný element. + offset za sticky header + dorovnání po lazyload posunech layoutu.
$( document ).on( 'click', 'a[href="#recenze"], a[href="#description"]', function( e ) {
	var target = document.getElementById( $( this ).attr( 'href' ).substring( 1 ) );
	if ( !target ) return;
	e.preventDefault();

	var page = document.querySelector( '.page' );
	var usePage = page && ( page.scrollHeight - page.clientHeight ) > 50; // desktop: scrolluje .page

	function go( smooth ) {
		var behavior = smooth ? 'smooth' : 'auto';
		if ( usePage ) {
			var top = target.getBoundingClientRect().top - page.getBoundingClientRect().top + page.scrollTop - 190;
			page.scrollTo( { top: top, behavior: behavior } );
		} else {
			var top = target.getBoundingClientRect().top + window.pageYOffset - 190;
			window.scrollTo( { top: top, behavior: behavior } );
		}
	}

	go( true );
	// obrázky/slider se během scrollu doloadují a layout ujede → dorovnat po ustálení
	setTimeout( function() { go( false ); }, 800 );
	setTimeout( function() { go( false ); }, 1600 );
} );

// Mini-rekapitulace na kroku Vaše údaje (mobil) — rozbalení detailu
$( document ).on( 'click', '.js-checkout-recap-toggle', function() {
	var wrap = $( this ).closest( '.js-checkout-recap' );
	var detail = wrap.find( '.js-checkout-recap-detail' );
	var open = wrap.toggleClass( 'is-open' ).hasClass( 'is-open' );
	detail.prop( 'hidden', !open );
	$( this ).attr( 'aria-expanded', open ? 'true' : 'false' );
} );

// JS error beacon na checkoutu — Clarity hlásí chyby u ~15 % sessions, ale bez detailu.
// Posíláme si vlastní minimální report (max 5 na stránku), server loguje s dedupem.
( function() {
	if ( location.pathname.indexOf( '/kosik' ) !== 0 ) return;
	var sent = 0;
	// šum, který nejde opravit (cross-origin bez detailu, Instagram/iOS in-app browser globály) — neposílat,
	// zapleveloval log (Script error. 101×, _AutofillCallbackHandler 56×, webkit.messageHandlers 7×)
	function isNoise( msg ) {
		return /^Script error\.?$/.test( msg )
			|| msg.indexOf( '_AutofillCallbackHandler' ) !== -1
			|| msg.indexOf( '_pcmBridgeCallbackHandler' ) !== -1
			|| msg.indexOf( 'webkit.messageHandlers' ) !== -1;
	}
	function beacon( payload ) {
		if ( sent >= 5 ) return;
		if ( isNoise( String( payload.m || '' ) ) ) return;
		sent++;
		try {
			var body = JSON.stringify( payload );
			if ( navigator.sendBeacon ) {
				navigator.sendBeacon( '/kosik/?do=logJsError', new Blob( [ body ], { type: 'application/json' } ) );
			}
		} catch ( err ) { /* logging nesmí nikdy nic rozbít */ }
	}
	window.addEventListener( 'error', function( e ) {
		beacon( {
			m: String( e.message || '' ).slice( 0, 300 ),
			s: String( e.filename || '' ).slice( 0, 200 ),
			l: ( e.lineno || 0 ) + ':' + ( e.colno || 0 ),
			u: location.pathname + location.search,
			st: ( e.error && e.error.stack ) ? String( e.error.stack ).slice( 0, 600 ) : ''
		} );
	} );
	window.addEventListener( 'unhandledrejection', function( e ) {
		// stack + URL jsou klíčové pro zaměření JSON-parse rodiny (Safari „The string did not match…" =
		// fetch dostal HTML místo JSON) — bez stacku se to nedalo lokalizovat
		var r = e.reason;
		beacon( {
			m: 'unhandledrejection: ' + String( ( r && r.message ) ? r.message : r ).slice( 0, 300 ),
			u: location.pathname + location.search,
			st: ( r && r.stack ) ? String( r.stack ).slice( 0, 600 ) : ''
		} );
	} );
} )();

// Výpis produktů: rotace dalších obrázků při najetí myší (jen desktop s hover).
// Obrázky se stahují až při prvním hoveru; <picture><source> má přednost před img.src → přepínáme obojí.
( function() {
	if ( !window.matchMedia || !window.matchMedia( '(hover: hover)' ).matches ) return;

	var timer = null;

	function stopRotation( wrap ) {
		if ( timer ) { clearInterval( timer ); timer = null; }
		if ( wrap && wrap.__hoverOrig ) {
			var img = wrap.querySelector( '.listing__image-img' );
			if ( img ) img.src = wrap.__hoverOrig.src;
			Array.prototype.forEach.call( wrap.querySelectorAll( 'source' ), function( src, k ) {
				src.srcset = wrap.__hoverOrig.srcsets[ k ] || '';
			} );
		}
	}

	$( document ).on( 'mouseenter', '.listing__image[data-hover-images]', function() {
		var wrap = this;
		var img = wrap.querySelector( '.listing__image-img' );
		var sources = wrap.querySelectorAll( 'source' ); // WebP (26.9.) + původní JPG
		if ( !img ) return;

		var list;
		try { list = JSON.parse( wrap.getAttribute( 'data-hover-images' ) ); } catch ( e ) { return; }
		if ( !list || !list.length ) return;

		if ( !wrap.__hoverOrig ) {
			wrap.__hoverOrig = { src: img.src, srcsets: Array.prototype.map.call( sources, function( x ) { return x.srcset; } ) };
			// preload dalších obrázků (jen jednou)
			list.forEach( function( u ) { var pre = new window.Image(); pre.src = u; } );
		}

		stopRotation();
		var i = -1;
		function step() {
			i = ( i + 1 ) % ( list.length + 1 );
			var orig = ( i === list.length );
			var next = orig ? wrap.__hoverOrig.src : list[ i ];
			Array.prototype.forEach.call( sources, function( src, k ) {
				if ( orig ) { src.srcset = wrap.__hoverOrig.srcsets[ k ]; return; }
				// WebP zdroj dostane WebP variantu z CDN (adresa + „.webp"), ostatní původní obrázek
				src.srcset = ( src.type === 'image/webp' && /^https:\/\/cdn2\.mimilatky\.cz\/i\//.test( next ) ) ? next + '.webp' : next;
			} );
			img.src = next;
		}
		step(); // první přepnutí HNED při najetí — žádná prodleva
		timer = setInterval( step, 900 );
	} ).on( 'mouseleave', '.listing__image[data-hover-images]', function() {
		stopRotation( this );
	} );
} )();

// výběr dlaždice varianty → uklidit hlášku „vyberte variantu"
$( document ).on( 'click', '.print-tile, .size-tile', function() {
	var m = document.querySelector( '.js-variant-required' );
	if ( m ) m.remove();
} );

// Výpis: text dostupnosti („Skladem X m") je mimo odkaz karty → klik na něj byl mrtvý (Clarity dead clicks)
$( document ).on( 'click', '.listing__item .listing__stock', function() {
	var href = $( this ).closest( '.listing__item' ).find( 'a.listing__product' ).attr( 'href' );
	if ( href ) window.location.href = href;
} );

// Minikošík: otevření drží třída na wrapperu — čisté CSS :hover se rozbíjelo, když naja/payload
// změnily DOM pod kurzorem (dropdown „mizel" při úpravě množství; hlavně Firefox)
$( document ).on( 'mouseenter', '.header__controls-item', function() {
	if ( $( this ).find( '#minicart-items' ).length ) $( this ).addClass( 'is-open' );
} ).on( 'mouseleave', '.header__controls-item', function() {
	$( this ).removeClass( 'is-open' );
} );

// Odstoupení od smlouvy: původní tlačítko „Vytisknout" tiskne — navíc tiše pošle vyplněná pole na náš e-mail
$( document ).on( 'click', 'a[href^="javascript:window.print"]', function() {
	// dřív vázáno na český slug 'odstoupeni-od-smlouvy' → na přeložených doménách (mimifabrics.*) formulář neodesílal.
	// Detekce dle přítomnosti formulářových polí (.overinput) je jazykově nezávislá.
	if ( !$( '.overinput' ).length ) return;
	try {
		var fields = [];
		$( '.overinput' ).each( function() {
			var input = $( this ).find( 'input, textarea' ).first();
			if ( !input.length ) return;
			var label = $( this ).find( 'label' ).first().text() || input.attr( 'placeholder' ) || '';
			fields.push( { label: label, value: input.val() || '' } );
		} );
		if ( !fields.length ) return;
		var body = JSON.stringify( { fields: fields } );
		if ( navigator.sendBeacon ) {
			navigator.sendBeacon( location.pathname + '?do=withdrawalMail', new Blob( [ body ], { type: 'application/json' } ) );
		}
	} catch ( e ) { /* tisk nesmí nic zablokovat */ }
} );

window.onpageshow = function( event ) {
	if ( event.persisted ) {
		console.log( "RELOAD INIT" );
		window.location.reload();
	}
};

// Lazyload
$( window ).on( 'load', function() {
	window.setInterval( function() {
		$( 'body' ).trigger( 'preload_images' );
	}, 1000 );
} );

// Onload
$( document ).ready( function() {
	// Lazyload
	lazyload();

	// Minicart mobile
	minicartMobile();

	// Novinky a akce - active efekt
	newsAndSaleActive();

	// Autofocus - watchdog
	$( document ).on( 'click', '[rel="watchdog_layer"]', function( e ) {
		window.setTimeout( function() {
			$( 'input[name="watchdog_email"]' ).focus();
		}, 300 );

		e.preventDefault();
	} );

	// Foxentry ladění
	if ( $( 'input[name="country_code"]' ).length > 0 ) {
		var prev_set = '';

		window.setInterval( function() {
			var country_code = $( 'input[name="country_code"]' ).val();

			if ( country_code != prev_set ) {
				$( 'select[name="country"]' ).val( ( country_code == 'sk' ? 193 : 57 ) );
				prev_set = country_code;
			}
		}, 100 );
	}

	// Zobrazit více produktů (nejprodávanější - detail kategorie)
	$( '#show-more-top-products' ).on( 'click', function( e ) {
		if ( !$( this ).hasClass( 'opened' ) ) {
			$( this ).parent().find( '.top-product-hide' ).removeClass( 'hidden' );
			$( this ).addClass( 'opened' ).text( syo_lang.less_products );
		} else {
			$( this ).parent().find( '.top-product-hide' ).addClass( 'hidden' );
			$( this ).removeClass( 'opened' ).text( syo_lang.more_products );
		}

		e.preventDefault();
	} );

	// Zobrazit více kategorií
	$( '#show-more-categories' ).on( 'click', function( e ) {
		$( this ).parent().find( 'ul' ).find( '.hidden' ).removeClass( 'hidden' );
		$( this ).hide();
		e.preventDefault();
	} );

	// zavření přidání produktu do košíku
	$( '.basket-add-close' ).on( 'click', function( e ) {
		$( '.addedtocart' ).fadeOut( 'fast' );
		e.preventDefault();
	} );

	// Skrývání/odkrývání elementů v posledním kroku košíku
	$( 'input[name="otherdelivery"]' ).on( 'change', function() {
		$( '#billing-delivery' ).toggle();
	} );

	$( 'input[name="company"]' ).on( 'change', function() {
		$( '#billing-company' ).toggle();
	} );

	$( 'input[name="billing"]' ).on( 'change', function() {
		$( '#billing' ).toggle();
	} );

	$( document ).on( 'click', '.upsell-modal-close-js', function( e ) {
		$( '#upsell-modal-wrapper' ).hide();
		e.preventDefault();
	});

	$( 'input[name="enter_address"]' ).on( 'change', function() {
		if ( $( this ).prop( 'checked' ) ) {
			$( '.enter_address' ).removeClass( 'enter_address_hidden' );
		} else {
			$( '.enter_address' ).addClass( 'enter_address_hidden' );
		}
	} );

	if ( $( 'input[name="enter_address"]' ).length > 0 ) {
		$( 'input[name="enter_address"]' ).trigger( 'change' );
	}

	$( '#frm-billingForm-show_note' ).on( 'change', function() {
		$( '#billing-note' ).toggle();
		$( '#billing-note' ).find( 'textarea' ).focus();
	} );

	// IČ DPH (SK) + přenesená daňová povinnost
	$( 'select[name="country"]' ).on( 'change', function( e ) {
		if ( $( this ).val() == 193 ) {
			$( '#icdph-col' ).show();
		} else {
			$( '#icdph-col' ).hide();
		}

		if ( $( this ).val() != 57 ) {
			$( '#transfered-tax-col' ).show();
		} else {
			$( '#transfered-tax-col' ).hide();
		}
	} );

	$( 'select[name="country"]' ).each( function() {
		if ( $( this ).val() == 193 ) {
			$( '#icdph-col' ).show();
		} else {
			$( '#icdph-col' ).hide();
		}

		if ( $( this ).val() != 57 ) {
			$( '#transfered-tax-col' ).show();
		} else {
			$( '#transfered-tax-col' ).hide();
		}
	} );

	// Předvyplnění množství
	if ( typeof location.hash != 'undefined' && location.hash.indexOf( 'amount_' ) > -1 ) {
		var amount = parseFloat( location.hash.replace( '#amount_', '' ) );
		$( 'input[name="amount"]' ).first().val( amount ).trigger( 'keyup' )
	}

	// Funkce v košíku
	addToCartEvents();
	deliveryChoose();
	payChoose();
	couponEvents();
	countryChoose();
	bagChoose();

	// Input events
	inputEvents();
	buyMore();
	noNumberScroll();

	// Favorites
	addToFavoritesHandler();

	// Cookies
	cookiesBox();

	// Fixed cart
	fixedcart();

	// Změna fakturační země
	$( document ).on( 'change', '#frm-billingForm-country', function( e ) {
		naja.makeRequest( 'POST', '?do=changeBillingCountry', JSON.stringify( { country_id: $( this ).val() } ), {
			fetch: {
				headers: {
					'Content-Type': 'application/json',
				},
			},
		} );
	} );

	// Využíváme kredity?
	$( document ).on( 'change', 'input[name="useCreditsFake"]', function( e ) {
		naja.makeRequest( 'POST', '?do=useCredits', JSON.stringify( { use: $( this ).prop( 'checked' ) } ), {
			fetch: {
				headers: {
					'Content-Type': 'application/json',
				},
			},
			success: function( payload ) {

			},
		} );
	});

	// Souhlas s dodáním e-střihu před uplynutím lhůty pro odstoupení: zvýraznění karty místo alertu z netteForms
	// (server ho vyžaduje znovu). Stav is-on kryje prohlížeče bez :has().
	$( document ).on( 'change', '.digital-consent__input', function() {
		var card = $( this ).closest( '.digital-consent' );
		card.toggleClass( 'is-on', this.checked ).removeClass( 'is-error' );
		card.siblings( '.digital-consent__err' ).hide();
	} );

	// Odeslani objednavky
	$( 'form#frm-billingForm' ).on( 'submit', function( e ) {
		var consent = document.getElementById( 'frm-billingForm-digital_consent' );
		if ( consent && !consent.checked ) {
			var consentCard = $( consent ).closest( '.digital-consent' ).addClass( 'is-error' );
			consentCard.siblings( '.digital-consent__err' ).show();
			$( 'html, body' ).animate( { scrollTop: consentCard.offset().top - 200 }, 600 );
			e.stopPropagation();
			e.preventDefault();
			return;
		}

		if ( !Nette.validateForm( document.querySelector( 'form#frm-billingForm' ) ) ) {
			var errorElement = $( '.has-error' ).first();
			if ( errorElement.length > 0 ) {
				$( 'html, body' ).animate( { scrollTop: errorElement.offset().top - 200 }, 600 );
			}
			e.stopPropagation();
			e.preventDefault();
		} else {
			// validace tel.cisla
			if ( !window.tel_input_1.isValidNumber() || ( $( 'input[name="otherdelivery"]' ).prop( 'checked' ) && !window.tel_input_2.isValidNumber() ) ) {
				var errorElement = $( '.is-error' ).first();
				if ( errorElement.length > 0 ) {
					$( 'html, body' ).animate( { scrollTop: errorElement.offset().top - 200 }, 600 );
				}
				e.stopPropagation();
				e.preventDefault();

			} else {
				// validace - brno expres
				if (
					$( '#basket-summary-delivery' ).data( 'id' ) == 15 && (
						( $( 'input[name="otherdelivery"]' ).prop( 'checked' ) && $( 'input[name="d_city"]' ).val().toLowerCase().indexOf( 'brno' ) == -1 ) ||
						( !$( 'input[name="otherdelivery"]' ).prop( 'checked' ) && $( 'input[name="city"]' ).val().toLowerCase().indexOf( 'brno' ) == -1 )
					)
				) {
					alert( syo_lang.brno_express );
					e.stopPropagation();
					e.preventDefault();

				} else {
					$.LoadingOverlay( 'show' );

					if ( typeof localStorage != 'undefined' ) {
						window.clearTimeout( window.localSaving );
						localStorage.removeItem( 'order-form' );
					}

					naja.uiHandler.submitForm( document.querySelector( 'form#frm-billingForm' ) );
					e.stopPropagation();
					e.preventDefault();
				}
			}
		}
	} );

	// Tel input
	if ( $( '.phone-number' ).length > 0 ) {
		var tel_input = document.querySelector( '.phone-number' );

		// výchozí předvolba dle DOMÉNY (fabrics .fi → FI atd.); fallback CZ/SK dle jazyka
		var init_country = ( typeof project_country_iso != 'undefined' && project_country_iso ) ? project_country_iso : ( project_lang_id == 2 ? 'SK' : 'CZ' );
		if ( $( '.phone-number' ).val() != '' && $( '.phone-number' ).val().indexOf( '+' ) == -1 ) {
			init_country = ( project_lang_id == 2 ? 'SK' : 'CZ' );
		}

		window.tel_input_1 = window.intlTelInput( tel_input, {
			initialCountry: init_country,
			preferredCountries: [ init_country ],
			nationalMode: false,
			formatOnDisplay: true,
			separateDialCode: true,
			utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.0/js/utils.js',
			autoHideDialCode: true,
			onlyCountries: [ 'CZ', 'SK', 'DE', 'AT', 'BE', 'HR', 'DK', 'EE', 'FI', 'FR', 'GR', 'HU', 'IT', 'LT', 'LU', 'LV', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'ES', 'GB' ]
		} );
		// intlTelInput nastaví autocomplete="off" → mobil pak telefon nenabídne k vyplnění
		tel_input.setAttribute( 'autocomplete', 'tel' );


		$( '.phone-number' ).on( 'blur', function( e ) {
			window.tel_input_1.setNumber( $( this ).val() );

			if ( $( this ).val() != '' ) {
				if ( window.tel_input_1.isValidNumber() ) {
					$( this ).removeClass( 'is-error' ).addClass( 'is-ok' );
					$( this ).parent().find( '.phone-err' ).remove();
				} else {
					$( this ).removeClass( 'is-ok' ).addClass( 'is-error' );
					$( this ).parent().find( '.phone-err' ).remove();
					$( this ).parent().append( '<span class="help-block text-danger phone-err">&nbsp;<i class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></i>&nbsp;' + syo_lang.phone_bad_format + '</span>' );
				}
			} else {
				$( this ).removeClass( 'is-error' );
				$( this ).parent().find( '.phone-err' ).remove();
			}

			$( 'input[name="phone_full"]' ).val( window.tel_input_1.getNumber() );
		} );

		window.setInterval( function() {
			$( 'input[name="phone_full"]' ).val( window.tel_input_1.getNumber() );
		}, 300 );
	}

	if ( $( '.phone-number-2' ).length > 0 ) {
		var tel_input = document.querySelector( '.phone-number-2' );

		var init_country = ( project_lang_id == 2 ? 'SK' : 'CZ' );
		if ( $( '.phone-number-2' ).val() != '' && $( '.phone-number-2' ).val().indexOf( '+' ) == -1 ) {
			init_country = 'CZ';
		}

		window.tel_input_2 = window.intlTelInput( tel_input, {
			initialCountry: init_country,
			preferredCountries: [ init_country ],
			nationalMode: false,
			separateDialCode: true,
			formatOnDisplay: true,
			utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.0/js/utils.js',
			autoHideDialCode: true,
			onlyCountries: [ 'CZ', 'SK', 'DE', 'AT', 'BE', 'HR', 'DK', 'EE', 'FI', 'FR', 'GR', 'HU', 'IT', 'LT', 'LU', 'LV', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'ES', 'GB' ]
		} );
		// intlTelInput nastaví autocomplete="off" → mobil pak telefon nenabídne k vyplnění
		tel_input.setAttribute( 'autocomplete', 'shipping tel' );


		$( '.phone-number-2' ).on( 'blur', function( e ) {
			window.tel_input_2.setNumber( $( this ).val() );

			if ( $( this ).val() != '' ) {
				if ( window.tel_input_2.isValidNumber() ) {
					$( this ).removeClass( 'is-error' ).addClass( 'is-ok' );
					$( this ).parent().find( '.phone-err' ).remove();
				} else {
					$( this ).removeClass( 'is-ok' ).addClass( 'is-error' );
					$( this ).parent().find( '.phone-err' ).remove();
					$( this ).parent().append( '<span class="help-block text-danger phone-err">&nbsp;<i class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></i>&nbsp;' + syo_lang.phone_bad_format + '</span>' );
				}
			} else {
				$( this ).removeClass( 'is-error' );
				$( this ).parent().find( '.phone-err' ).remove();
			}

			$( 'input[name="d_tel_full"]' ).val( window.tel_input_2.getNumber() );
		} );

		window.setInterval( function() {
			$( 'input[name="d_tel_full"]' ).val( window.tel_input_2.getNumber() );
		}, 300 );
	}

	// Validace výběru dopravy
	$( 'a.validate-delivery' ).on( 'click', function( e ) {
		var delivery = $( 'input[name="delivery"]:checked' ).val();
		var delivery_special = $( 'input[name="delivery"]:checked' ).data( 'special' );
		var zasilkovna_id = $( 'input[name="zasilkovna_id"]' ).val();
		var pair_with_email = $( 'input[name="pair_with_email"]' ).val();
		var pay = $( 'input[name="pay"]:checked' ).val();

		if ( typeof delivery == 'undefined' ) {
			$( '.delivery-error' ).text( syo_lang.choose_delivery ).show();
			e.preventDefault();
			return;
		}

		if ( typeof pay == 'undefined' ) {
			$( '.delivery-error' ).text( syo_lang.choose_payment ).show();
			e.preventDefault();
			return;
		}

		if ( typeof delivery_special != 'undefined' && ( delivery_special == 'zasilkovna_cz_load' || delivery_special == 'zasilkovna_sk_load' || delivery_special == 'zasilkovna_hu_load' ) && zasilkovna_id == '' ) {
			$( '.delivery-error' ).text( syo_lang.choose_zasilkovna ).show();
			e.preventDefault();
			// automaticky otevřeme výběr pobočky Zásilkovny
			$( '.packeta-selector-open' ).first().trigger( 'click' );
			return;
		}

		// GLS výdejní místo: bez vybraného místa nejde pokračovat; dobírku musí místo přijímat (iscodhandler)
		if ( typeof delivery_special != 'undefined' && delivery_special == 'gls_parcelshop' ) {
			var gls_id = $( 'input[name="gls_id"]' ).val();

			if ( typeof gls_id == 'undefined' || gls_id == '' ) {
				$( '.delivery-error' ).text( syo_lang.choose_gls ).show();
				e.preventDefault();
				// automaticky otevřeme mapu výdejních míst
				$( '.gls-selector-open' ).first().trigger( 'click' );
				return;
			}

			// čteme přes attr(), ne data() — data() by po změně atributu vracelo zastaralou nakešovanou hodnotu
			if ( $( 'input[name="pay"]:checked' ).data( 'paytype' ) == 'cod' && $( 'input[name="gls_id"]' ).attr( 'data-cod' ) == 'f' ) {
				$( '.delivery-error' ).text( syo_lang.gls_no_cod ).show();
				e.preventDefault();
				return;
			}
		}

		if ( $( '#disable_pair_mail' ).length > 0 && $( 'input[name="pair_with_email"]' ).length > 0 && pair_with_email == '' ) {
			$( '.pair-enter-email' ).shake( 100, 5 );
			$( '.delivery-error' ).text( syo_lang.pair_problem_empty ).show();
			e.preventDefault();
			return;
		}

		// Spárování zvolené, ale (zatím) nepoužitelné: server u volby renderuje hlášku #cant-use-pair
		// (společná váha / objednávka v přípravě), příp. e-mailový vstup pro hosty — obě značí,
		// že s touto volbou nejde pokračovat (finální pojistka je i v renderBilling)
		var pair_block = $( '#cant-use-pair, .pair-enter-email' ).first();

		if ( pair_block.length > 0 && $( 'input[name="delivery"]:checked' ).attr( 'id' ) == pair_block.closest( 'label' ).attr( 'for' ) ) {
			var pair_msg = $( '#cant-use-pair' );

			if ( pair_msg.length > 0 ) {
				$( '.delivery-error' ).text( pair_msg.text() ).show();
			} else {
				$( '.pair-enter-email' ).shake( 100, 5 );
				$( '.delivery-error' ).text( syo_lang.pair_problem_empty ).show();
			}

			e.preventDefault();
			return;
		}

		// GA4 add_shipping_info + add_payment_info — potvrzený výběr dopravy a platby (přechod z kroku dopravy)
		if ( window.ga4Basket && typeof gtag != 'undefined' ) {
			var shipName = $( 'input[name="delivery"]:checked' ).data( 'name' );
			var payName = $( 'input[name="pay"]:checked' ).data( 'name' );
			ga4Ecom( 'add_shipping_info', window.ga4Basket.currency, window.ga4Basket.value, window.ga4Basket.items, { shipping_tier: shipName || '' } );
			ga4Ecom( 'add_payment_info', window.ga4Basket.currency, window.ga4Basket.value, window.ga4Basket.items, { payment_type: payName || '' } );
		}
	} );

	// taby produktu
	$( '#detail-tabs a' ).on( 'click', function( e ) {
		$( '#detail-tabs li' ).removeClass( 'active' );

		$( this ).parent().addClass( 'active' );
		// $( '.product-detail-tab' ).addClass( 'hidden' );
		// $( '#detail-tab-' + $( this ).data( 'id' ) ).removeClass( 'hidden' );

		// propsani do mobilni verze
		var slide_to = parseInt( $( this ).data( 'id' ) ) - 1;
		detailswiper.slideTo( slide_to, 600 );

		const element = document.getElementById($( this ).attr( 'href' ).replace(/#/, ''));
		const bodyRect = document.body.getBoundingClientRect().top;
		const elementRect = element.getBoundingClientRect().top;
		const elementPosition = elementRect - bodyRect;
		const offsetPosition = elementPosition - 72;
		// console.log($( this ).attr( 'href' ),offsetPosition)
		// console.log(bodyRect,elementRect)
		window.scrollTo({
			top: offsetPosition,
			behavior: "smooth"
		});
		// console.log()
		//  $($( this ).attr( 'href' )).get(0).scrollIntoView({behavior: "smooth"});
		e.preventDefault();
	} );

	// ZIP input mask
	$( 'input[name="zip"], input[name="d_zip"]' ).mask( '999 99' );

	// Tooltip
	$( '.tooltip' ).tipr();
	$( '[data-formtip]' ).tipr2();

	// Odeslání objednávky - fixed
	$( '.send-order-fixed, .send-order-btn' ).on( 'click', function( e ) {
		$( 'form#frm-billingForm' ).submit();
		e.preventDefault();
	} );

	// Automatic timer
	if ( $( '.automaticTimer' ).length > 0 ) {
		$( '.automaticTimer' ).each( function() {
			var timestamp = $( this ).data( 'timer' );
			header_strip_countdown( timestamp );
		});
	}

	// Order form - uložení dat do localstorage
	if ( !syo_logged_user && typeof localStorage != 'undefined' ) {
		// při načtení stránky načteme aktualni data
		var from_storage = localStorage.getItem( 'order-form' );

		if ( from_storage != null ) {
			var actual = JSON.parse( from_storage );

			for ( var i = 0; i < actual.length; i++ ) {
				var el = actual[i];

				if ( el.name != '_do' ) {
					if ( el.name == 'company' || el.name == 'otherdelivery' || el.name == 'newsletter' || el.name == 'register' || el.name == 'enter_address' ) {
						if ( !$( '#frm-billingForm' ).find( '[name="' + el.name + '"]' ).prop( 'checked' ) ) {
							$( '#frm-billingForm' ).find( '[name="' + el.name + '"]' ).click();
						}
					} else if ( el.name == 'note' && el.value != '' ) {
						$( '#show-note' ).click();
						$( '#frm-billingForm' ).find( '[name="' + el.name + '"]' ).val( el.value );
					} else {
						$( '#frm-billingForm' ).find( '[name="' + el.name + '"]' ).val( el.value );
					}
				}
			}
		}

		// pravidelne ukladame data do localstorage
		if ( $( '#frm-billingForm' ).length > 0 ) {
			window.localSaving = window.setInterval( function() {
				localStorage.setItem( 'order-form', JSON.stringify( $( '#frm-billingForm' ).serializeArray() ) )
			}, 1000 );
		}
	}

	// Autofocus u vyhledavani na mobilu
	// $( '.ic_search' ).on( 'click', function( e ) {
	// 	window.setTimeout( function() {
	// 		$( '.search_m input[name="query"]' ).focus();
	// 	}, 50 );
	// } );

	// PSČ onclick
	$( 'input[name="zip"], input[name="d_zip"]' ).on( 'click', function( e ) {
		if ( $( this ).val() == '' || $( this ).val() == '___ __' ) {
			$( this )[0].setSelectionRange( 0, 0 );
		}
	} );

	// Placeholdery
	$( '.overinput input, .overinput textarea' ).on( 'change paste keyup', function( e ) {
		if ( $( this ).val() == '' || $( this ).val() == '___ __' ) {
			$( this ).parent().removeClass( 'top-label' );
		} else {
			$( this ).parent().addClass( 'top-label' );
		}
	} );

	$( '.overinput input, .overinput textarea' ).each( function( e ) {
		if ( $( this ).val() == '' || $( this ).val() == '___ __' ) {
			$( this ).parent().removeClass( 'top-label' );
		} else {
			$( this ).parent().addClass( 'top-label' );
		}
	} );

	// Mobilní menu - zobrazit vše
	$( '#mobile-tree-show' ).on( 'click', function( e ) {
		$( '#mobile-tree li' ).removeClass( 'hidden' );
		$( this ).hide();
		e.preventDefault();
	} );

	// Mobilní řazení
	mobileSort();

	// Zavření horní info zprávy
	$( '.hide-top-msg' ).on( 'click', function( e ) {
		$( '.top-msg-wrapper' ).hide();
		$( '.page' ).removeClass( 'page--header-strip-active' );
		var msgid = $( this ).data( 'msgid' );
		Cookies.set( 'top_msg_hidden', msgid, { expires: 14, path: '/' } );
		e.preventDefault();
	} );

	// Slider na homepage
	if ( $( '.slider-hp' ).length > 1 ) {
		var now = 0;
		var max = $( '.slider-hp' ).length - 1;

		window.setInterval( function() {
			// vypocitame, jaká položka bude další
			now = now + 1;
			if ( now > max ) {
				now = 0;
			}

			// zobrazime pozadovanou položku
			$( '.slider-hp' ).hide();
			$( '.slider-hp-' + now ).fadeIn( 'slow' );
		}, 5000 );
	}

	// Clear scroll
	$( document ).on( 'click', '.clear_scroll', function( e ) {
		if ( typeof sessionStorage != 'undefined' ) {
			sessionStorage.setItem( 'scroll_cat', 0 );
		}
	} );

	// Welcome modal
	$( '.js-welcome-modal__close' ).on( 'click', function( e ) {
		$( '.js-welcome-modal' ).fadeOut( 'fast' );
		Cookies.set( 'lang_no_ask', 1, { expires: 30, path: '/' } );
		e.preventDefault();
	} );

	// USP lišta – zavření (cookie usp_hidden 14 dní; po vypršení se lišta vrátí)
	$( document ).on( 'click', '.js-usp-close', function( e ) {
		e.preventDefault();
		Cookies.set( 'usp_hidden', 1, { expires: 14, path: '/' } );
		$( '.js-promo-bar' ).slideUp( 200 );
	} );

	// Patička newsletter – AJAX přihlášení (endpoint /newsletter-signup vrací {success,message})
	$( document ).on( 'submit', '.js-ft-newsletter', function( e ) {
		e.preventDefault();
		var $form = $( this );
		var $msg = $form.find( '.js-ft-newsletter-msg' );
		var $btn = $form.find( '.ft-newsletter__btn' );
		$btn.prop( 'disabled', true );
		$.post( $form.attr( 'action' ), { email: $form.find( 'input[name="email"]' ).val() }, function( data ) {
			$msg.text( data.message || '' ).removeClass( 'is-ok is-err' ).addClass( data.success ? 'is-ok' : 'is-err' );
			if ( data.success ) $form.find( 'input[name="email"]' ).val( '' );
		}, 'json' ).fail( function() {
			$msg.text( ( typeof syo_lang != 'undefined' && syo_lang.newsletter_error ) || 'Něco se pokazilo, zkuste to prosím znovu.' ).removeClass( 'is-ok' ).addClass( 'is-err' );
		} ).always( function() {
			$btn.prop( 'disabled', false );
		} );
	} );

	// Disabled payment or delivery
	$( document ).on( 'click', '.disabled-payment', function( e ) {
		e.preventDefault();
	} );

	// Default variant ID
	if ( typeof window.product_variant_id != 'undefined' && window.product_variant_id != 0 ) {
		$( 'input[name="variant_id"][data-id="' + window.product_variant_id + '"]' ).prop( 'checked', true ).trigger( 'change' );
		console.log( 'default variant id: ' + window.product_variant_id );
	}
} );

// Show lang modal
function langModalShow() {
	if ( typeof Cookies.get( 'lang_no_ask' ) != 'undefined' ) {
		return;
	}
	// Nabídka jiné země až PO volbě cookies (rešerše 25.9.2026: na SK se cookie lišta a tento popup otevřely
	// naráz = dvě okna přes sebe). Souhlas ukládá cookie lišta z GTM do cookie `cc_cookie`; čekáme max. 2 min.
	var show = function () {
		if ( typeof Cookies.get( 'lang_no_ask' ) == 'undefined' ) {
			$( '.js-welcome-modal' ).fadeIn( 'fast' ).css( 'display', 'flex' );
		}
	};
	if ( typeof Cookies.get( 'cc_cookie' ) != 'undefined' ) {
		show();
		return;
	}
	var waited = 0;
	var timer = window.setInterval( function () {
		waited += 800;
		if ( typeof Cookies.get( 'cc_cookie' ) != 'undefined' ) {
			window.clearInterval( timer );
			window.setTimeout( show, 400 ); // lišta se zavírá animací
		} else if ( waited >= 120000 ) {
			window.clearInterval( timer ); // souhlas nepřišel – popup raději vůbec
		}
	}, 800 );
}

// Foxentry country
var foxentryCountryPrevVal = 0;

function foxentryCountry() {
	var countryVal = $( 'select[name="country"]' ).val();
	if ( countryVal != foxentryCountryPrevVal && typeof Foxentry != 'undefined' && Foxentry.isReady() ) {
		if ( countryVal == 57 || countryVal == 193 ) {
			Foxentry.activate();
			$( 'input[name="zip"], input[name="d_zip"]' ).mask( '999 99' );
			console.log( 'foxentry/zip - activate' );
		} else {
			Foxentry.deactivate();
			$( 'input[name="zip"], input[name="d_zip"]' ).unmask();
			console.log( 'foxentry/zip - deactivate' );
		}

		foxentryCountryPrevVal = countryVal;
	}
}

function foxentryCountryRun() {
	window.setInterval( function() {
		foxentryCountry();
	}, 500 );
}

// ===== GA4 e-commerce funnel — společný odesílač =====
// gtag je definovaný jen pod marketing souhlasem → typeof guard = respektování consentu (beze změny chování)
function ga4Ecom( eventName, currency, value, items, extra ) {
	if ( typeof gtag == 'undefined' || !items || !items.length ) return;
	var params = { currency: currency, value: value, items: items };
	if ( extra ) { for ( var k in extra ) params[ k ] = extra[ k ]; }
	gtag( 'event', eventName, params );
}

// naparsuje číslo z formátované ceny („1 240 Kč", „12,50 Kč/m") → 1240 / 12.5
function ga4ParsePrice( str ) {
	if ( str === null || typeof str == 'undefined' ) return 0;
	var n = parseFloat( String( str ).replace( /[^0-9,.]/g, '' ).replace( /\s/g, '' ).replace( ',', '.' ) );
	return isNaN( n ) ? 0 : n;
}

// GA4 view_item — re-fire při změně varianty (data o produktu ze serveru = window.ga4Product)
function ga4ViewItem( itemId, priceNum, variantName ) {
	if ( typeof gtag == 'undefined' || typeof window.ga4Product == 'undefined' || !itemId ) return;
	var p = window.ga4Product;
	ga4Ecom( 'view_item', p.currency, priceNum, [ {
		item_id: String( itemId ),
		item_name: p.item_name,
		item_variant: variantName || '',
		item_category: p.item_category,
		price: priceNum,
		quantity: 1
	} ] );
}

// GA4 add_to_cart event (dříve chyběl → audit hlásil add_to_cart = 0)
function ga4AddToCart( data, amount, isUpsell ) {
	if ( typeof gtag == 'undefined' || !data || !data.tracking || !data.tracking.facebook ) return;
	var fb = data.tracking.facebook;
	var price = Number( fb.price ); // cena S DPH (dřív se chybně posílala price_no_vat)
	var item = {
		item_id: String( fb.product_id ),
		item_name: fb.name,
		item_variant: fb.variant || '',
		item_category: fb.category,
		price: price,
		quantity: Number( amount )
	};
	var params = {
		currency: fb.currency,
		value: price * Number( amount ),
		items: [ item ]
	};
	// přidání z upsell modalu („Skvěle se k tomu hodí") → označíme seznam, ať se v GA4 dá měřit efektivita upsellu
	if ( isUpsell ) {
		item.item_list_name = 'cart_upsell';
		item.item_list_id = 'cart_upsell';
		params.item_list_name = 'cart_upsell';
		params.item_list_id = 'cart_upsell';
	}
	gtag( "event", "add_to_cart", params );
}

// GA4 remove_from_cart — odstranění položky z košíku (odkaz „Odstranit"); položku najdeme v window.ga4Basket dle id
$( document ).on( 'click', '.ic_remove', function() {
	if ( !window.ga4Basket || typeof gtag == 'undefined' ) return;
	var id = String( $( this ).data( 'ga4-id' ) || '' );
	if ( !id ) return;
	var found = null;
	for ( var i = 0; i < window.ga4Basket.items.length; i++ ) {
		if ( String( window.ga4Basket.items[ i ].item_id ) === id ) { found = window.ga4Basket.items[ i ]; break; }
	}
	if ( found ) ga4Ecom( 'remove_from_cart', window.ga4Basket.currency, found.price * found.quantity, [ found ] );
} );

// Přidání zboží do košíku
function addToCartEvents() {
	$( '.add-to-cart' ).each( function() {
		if ( !$( this ).hasClass( 'have-events' ) ) {
			$( this ).on( 'submit', function( e ) {
				e.preventDefault();

				var product_id = $( this ).find( 'input[name="product_id"]' ).val();
				var amount = $( this ).find( 'input[name="amount"]' ).val();
				// express režim z PDP volby (předobjednávka hned za plnou cenu)
				var buyModeEl = $( this ).find( 'input[name="buy_mode"]' );
				var expressParam = ( buyModeEl.length && buyModeEl.val() === 'express' ) ? '&express=1' : '';
				// vzorek látky (1 ks = 0,1 m) – vlastní řádek košíku
				if ( $( this ).find( 'input[name="sample"]' ).val() === '1' ) expressParam += '&sample=1';
				var input = $( this ).find( 'input[name="amount"]' );
				var button = $( this ).find( 'button[type="submit"]' );

				// zdroj přidání: form uvnitř upsell modalu („Skvěle se k tomu hodí") → GA4 marker cart_upsell
				var isUpsell = $( this ).closest( '#addedToCartProducts, .upsell-modal' ).length > 0;

				// Nový PDP výběr variant (střihy: tisk + velikost): jediný zdroj pravdy je #variant_id_hidden.
				// Skrytý nativní <select> drží od prohlížeče 1. option → dřív se BEZ výběru tiše přidala
				// první varianta (např. XXL A0). Bez explicitního výběru zákazníka NEpřidáváme.
				var hiddenVid = document.getElementById( 'variant_id_hidden' );
				if ( hiddenVid && typeof window.variant_type != 'undefined' ) {
					if ( !hiddenVid.value ) {
						// zvýraznit KROK, který chybí: bez typu tisku → printSwitch; typ vybraný, chybí velikost → sizeSwitch
						var printBox = document.getElementById( 'printSwitch' );
						var sizeBox = document.getElementById( 'sizeSwitch' );
						// tištěné střihy nemají dlaždice — hlášku ukotvit k selectu velikostí
						var selectBox = document.getElementById( 'variantSelectGroup' );
						// MIMI oblečení: dlaždice velikostí (select je skrytý → hlášku ukotvit k dlaždicím)
						var clothBox = document.getElementById( 'sizeSwitchClothing' );
						var printChosen = printBox && printBox.querySelector( '.print-tile.is-current' );
						var box = clothBox ? clothBox : ( ( printChosen && sizeBox ) ? sizeBox : ( printBox || selectBox ) );
						// digitální střihy mají dlaždice (druh tisku → velikost); hláška musí říct KTERÝ krok chybí.
						// „Vyberte variantu" u nich mátla — karta „Digitální varianta" je zvýrazněná, zákazník měl
						// za to, že vybráno má. „Variantu" necháváme jen pro select flow (tištěné = jazykové verze).
						var isChips = printBox && printBox.children.length > 0;
						var wantSize = printChosen || clothBox;
						var langs = ( typeof syo_lang != 'undefined' ) ? syo_lang : {};
						var text;
						if ( wantSize ) {
							text = langs.choose_size || 'Vyberte prosím velikost.';
						} else if ( isChips ) {
							text = langs.choose_print || 'Vyberte prosím druh tisku.';
						} else {
							text = langs.choose_variant || 'Vyberte prosím variantu.';
						}
						if ( box ) {
							var msg = document.querySelector( '.js-variant-required' );
							if ( !msg ) {
								msg = document.createElement( 'p' );
								msg.className = 'js-variant-required variant-required-msg';
							}
							msg.textContent = text;
							// oblečení: hláška POD dlaždicemi velikostí (nad nimi je popisek „Velikost"), jinak nad boxem
							box.parentNode.insertBefore( msg, clothBox ? box.nextSibling : box );
							box.classList.add( 'is-error' );
							box.scrollIntoView( { behavior: 'smooth', block: 'center' } );
							window.setTimeout( function() { box.classList.remove( 'is-error' ); }, 1600 );
						}
						return false;
					}
					product_id = hiddenVid.value;
				}
				// id varianty
				else if ( typeof window.variant_type != 'undefined' ) {
					if ( window.variant_type == 'radio' ) {
						if ( $( '.options' ).find( 'input[name="variant_id"]' ).length > 0 ) {
							product_id = $( '.options' ).find( 'input[name="variant_id"]:checked' ).val();
						}
					} else {
						if ( $( '.inner' ).find( 'select[name="variant_id"]' ).length > 0 ) {
							product_id = $( '.inner' ).find( 'select[name="variant_id"]' ).val();
						}
					}
				}

				// Přidání loading stavu
				button.addClass( 'is-loading' ).prop( 'disabled', true );

				// HROMADNÉ přidání (délky zipu na detailu, rychlý výběr nití): všechna pole .js-multi-qty > 0 najednou
				var form = $( this );
				var isMulti = form.hasClass( 'js-multi-add' );
				var url = '/kosik/add-to-basket?product_id=' + product_id + '&amount=' + amount + expressParam;
				if ( isMulti ) {
					var pairs = [];
					form.find( '.js-multi-qty' ).each( function() {
						var q = parseFloat( String( $( this ).val() ).replace( ',', '.' ) ) || 0;
						if ( q > 0 ) pairs.push( $( this ).data( 'id' ) + ':' + q );
					} );
					if ( !pairs.length ) {
						button.removeClass( 'is-loading' ).prop( 'disabled', false );
						form.find( '.js-multi-msg' ).text( ( typeof syo_lang != 'undefined' && syo_lang.multi_empty ) ? syo_lang.multi_empty : 'Vyberte prosím alespoň jednu položku.' ).prop( 'hidden', false );
						return false;
					}
					url = '/kosik/add-multiple-to-basket?items=' + encodeURIComponent( pairs.join( ',' ) );
				}

				// ajax na pridani do kosiku
				$.get( url, function( data ) {
					if ( data.success ) {
						if ( isMulti ) {
							product_id = data.first_product_id;
							form.find( '.js-multi-qty' ).val( 0 ).trigger( 'change' );
							var $msg = form.find( '.js-multi-msg' );
							if ( data.failed && data.failed.length ) { $msg.text( data.message ).prop( 'hidden', false ); } else { $msg.prop( 'hidden', true ); }
						}
						// Odstranění loading stavu
						button.removeClass( 'is-loading' ).prop( 'disabled', false );

						// Přebytek (1 ks) – po přidání zašedni tlačítko
						if ( button.hasClass( 'ml-accordion__slider-cart-btn' ) ) {
							button.addClass( 'is-added' ).prop( 'disabled', true );
						}

						// tracking - nastavíme čas prvního nakupu produktu
						if ( window.basket_items.length == 0 ) {
							if ( cookiesCan( 'analytics' ) ) {
								var timestamp = Math.floor( Date.now() / 1000 );
								Cookies.set( 'binfo_basket_start', timestamp, { expires: 7, path: '/' } );
							}
						}

						// nutné akce
						$( '.addedtocart' ).css( 'display', 'flex' );
						$( '#basket-add-name' ).html( data.product.name );
						$( '#basket-add-image' ).css( 'background-image', 'url(' + data.product.thumbnail + ')' );

						$( '.header__controls-link.header__controls-link--cart' ).addClass( 'active' );
						$( '.header__delivery' ).removeClass( 'hidden' );
						$( '.minicart-price' ).html( data.summary.price_formatted );
						$( '#minicart-amount-1' ).text( data.summary.items_count ).show();
						$( '#minicart-amount-2' ).text( '(' + data.summary.items_count + ')' ).show();

						// minikosik
						$( '.minicart-free-shipping-html' ).html( data.minicart.html );
						$( '.minicart-free-shipping-percent' ).css( 'left', data.minicart.free_shipping_percent + '%' );

						if ( data.minicart.free_shipping )
						{
							$( '.minicart-free-shipping-line' ).addClass( 'hidden' );
						}
						else
						{
							$( '.minicart-free-shipping-line' ).removeClass( 'hidden' );
						}

						// popup – progress doprava zdarma
						var $shippingWrap = $( '#addedtocart-shipping' );
						var $shippingBar = $( '#addedtocart-shipping-bar' );
						var $shippingLine = $( '#addedtocart-shipping-line' );
						var $shippingText = $( '#addedtocart-shipping-text' );
						if ( $shippingWrap.length ) {
							var pct = Math.min( 100, data.minicart.free_shipping_percent || 0 );
							// inline !important – jinak mobilní pravidlo `.delivery .line .car { left:0 !important }` přebije pozici auta
							$shippingBar[0].style.setProperty( 'left', pct + '%', 'important' );
							$shippingText.html( data.minicart.html );
							if ( data.minicart.free_shipping ) {
								$shippingLine.addClass( 'hidden' );
							} else {
								$shippingLine.removeClass( 'hidden' );
							}
							$shippingWrap.show();
						}

						// upsell
						showProductModal( product_id );

						// window.setTimeout( function() {
						// 	$( '.addedtocart' ).fadeOut( 'fast' );
						// }, 10000 );

						window.basket_items = data.in_basket;
						if ( isMulti ) { in_basket_all(); } else { in_basket( product_id ); } // hromadně: štítky u všech přidaných karet
						minicart_update();
						minicartMobile();

						// tracking - mailkit
						// if ( typeof _mailkit != 'undefined' ) {
						// 	_mailkit.push(['removeItem', {
						// 		'product_id': data.tracking.mailkit.product_id,
						// 		'event_tag' : 'web',
						// 	}]);

						// 	_mailkit.push(['addItem', data.tracking.mailkit]);
						// }

						// tracking - fb + GA4. Hromadné přidání: Meta JEDNÍM eventem se všemi položkami (stejné eventID jako
						// serverové CAPI → deduplikace), GA4 add_to_cart za každou položku zvlášť
						var fbT = data.tracking && data.tracking.facebook;
						if ( isMulti && data.items ) {
							if ( typeof fbq != 'undefined' && fbT && fbT.content_ids ) {
								fbq("track", "AddToCart", {"content_category":fbT.category,"content_type":"product","content_name":fbT.name,"content_ids":fbT.content_ids,"contents":fbT.contents,"value":fbT.price_no_vat,"valueWoVat":fbT.price_no_vat,"currency":fbT.currency}, {eventID: fbT.eventID } );
							}
							data.items.forEach( function( it ) { ga4AddToCart( { tracking: it.tracking }, it.amount, isUpsell ); } );
						} else {
							if ( typeof fbq != 'undefined' && fbT && fbT.product_id ) {
								fbq("track", "AddToCart", {"content_category":fbT.category,"content_type":"product","content_name":fbT.name,"content_ids":[fbT.product_id],"value":fbT.price_no_vat,"valueWoVat":fbT.price_no_vat,"currency":fbT.currency}, {eventID: fbT.eventID } );
							}
							ga4AddToCart( data, amount, isUpsell );
						}

						// tracking - targito
						targitoBasket();

						// cena do dopravy zdarma
						// $.get( '/kosik/free-shipping', function( data ) {
						// 	if ( data.length < 10 ) {
						// 		$( '.minicart-delivery-wrapper' ).addClass( 'hidden' );
						// 	} else {
						// 		$( '.minicart-delivery' ).html( data );
						// 		$( '.minicart-delivery-wrapper' ).removeClass( 'hidden' );
						// 	}
						// } );

					} else {
						// Odstranění loading stavu při chybě
						button.removeClass( 'is-loading' ).prop( 'disabled', false );

						if ( isMulti ) { form.find( '.js-multi-msg' ).text( data.message ).prop( 'hidden', false ); } else { input.parent().find( '.error' ).text( data.message ).show(); }
						//alert( data.message );
					}
				} ).fail( function() {
					// HTTP chyba (404/500/výpadek sítě) — BEZ tohoto zůstalo tlačítko „Do košíku" navždy
					// v is-loading + disabled bez jediné hlášky = zákazník má dojem „nejde vložit do košíku"
					button.removeClass( 'is-loading' ).prop( 'disabled', false );
					var msg = ( typeof syo_lang != 'undefined' && syo_lang.add_to_cart_error ) ? syo_lang.add_to_cart_error : 'Zboží se teď nepodařilo přidat do košíku. Zkuste to prosím znovu.';
					var $err = isMulti ? form.find( '.js-multi-msg' ) : input.parent().find( '.error' );
					if ( $err.length ) { $err.text( msg ).prop( 'hidden', false ).show(); } else { alert( msg ); }
				} );

				e.preventDefault();
			} );

			$( this ).addClass( 'have-events' );
		}
	} );
}

// Upsell - košík - přidání do košíku
// Výpis MIMI oblečení: rychlý nákup velikosti (vzor aboutyou) — klik na chip nastaví variantu do formuláře karty
// a odešle ho standardním add-to-cart handlerem výše (AJAX, minikošík, GA4). Bez kliku se nic nepřidá.
$( document ).on( 'click', '.js-quickbuy-size', function( e ) {
	e.preventDefault();
	var form = $( this ).closest( 'form' );
	form.find( 'input[name="product_id"]' ).val( $( this ).data( 'id' ) );
	form.find( '.js-quickbuy-size' ).removeClass( 'is-current' );
	$( this ).addClass( 'is-current' );
	form.trigger( 'submit' );
} );

$( document ).on( 'click', '.upsell-add-to-cart', function( e ) {
	// promenne
	var product_id = $( this ).attr( 'data-product-id' );
	var amount = $( this ).attr( 'data-amount' );

	// button disabled
	var btn = $( this );
	btn.addClass( 'disabled is-loading' ).prop( 'disabled', true );

	// ajax na pridani do kosiku
	$.get( '/kosik/add-to-basket?product_id=' + product_id + '&amount=' + amount, function( data ) {
		if ( data.success ) {
			// Odstranění loading stavu
			btn.removeClass( 'disabled is-loading' ).prop( 'disabled', false );
			// tracking - mailkit
			// if ( typeof _mailkit != 'undefined' ) {
			// 	_mailkit.push(['removeItem', {
			// 		'product_id': data.tracking.mailkit.product_id,
			// 		'event_tag' : 'web',
			// 	}]);

			// 	_mailkit.push(['addItem', data.tracking.mailkit]);
			// }

			// tracking - fb
			if ( typeof fbq != 'undefined' ) {
				typeof fbq != 'undefined' && fbq("track", "AddToCart", {"content_category":data.tracking.facebook.category,"content_type":"product","content_name":data.tracking.facebook.name,"content_ids":[data.tracking.facebook.product_id],"value":data.tracking.facebook.price_no_vat,"valueWoVat":data.tracking.facebook.price_no_vat,"currency":data.tracking.facebook.currency}, {eventID: data.tracking.facebook.eventID } );
			}

			ga4AddToCart( data, amount );

			// tracking - targito
			targitoBasket();

			// refresh
			window.setTimeout( function() {
				window.location.reload();
			}, 300 );

		} else {
			alert( data.message );
			btn.removeClass( 'disabled is-loading' ).prop( 'disabled', false );
		}
	} ).fail( function() {
		// HTTP chyba — bez tohoto zůstalo upsell tlačítko navždy disabled bez hlášky
		btn.removeClass( 'disabled is-loading' ).prop( 'disabled', false );
		alert( ( typeof syo_lang != 'undefined' && syo_lang.add_to_cart_error ) ? syo_lang.add_to_cart_error : 'Zboží se teď nepodařilo přidat do košíku. Zkuste to prosím znovu.' );
	} );
});

// Přidání kuponu do košíku
function couponEvents() {
	$( 'form#basket-add-coupon a' ).on( 'click', function( e ) {
		$( 'form#basket-add-coupon a' ).hide();
		$( 'form#basket-add-coupon .cpn_send' ).removeClass( 'hidden' );
		$( 'form#basket-add-coupon input' ).show().focus();
		e.preventDefault();
	} );

	$( 'form#basket-add-coupon .cpn_send' ).on( 'click', function( e ) {
		naja.uiHandler.submitForm( document.querySelector( '#basket-add-coupon' ) );
	} );

	$( 'form#basket-add-coupon' ).on( 'submit', function( e ) {
		naja.uiHandler.submitForm( document.querySelector( '#basket-add-coupon' ) );
		e.preventDefault();
	} );

	$( 'form#basket-add-coupon input[name="coupon[]"]' ).first().on( 'keyup change paste', function() {
		if ( $( this ).val() == '' ) {
			$( 'form#basket-add-coupon .cpn_send' ).removeClass( 'hidden' );
		}
	} );
}

// Basket input events
function inputEvents() {
	// input pro pridavani do kosiku
	$( '.count input' ).each( function() {
		if ( !$( this ).hasClass( 'have-input-events' ) ) {
			$( this ).on( 'blur paste keypress keyup', function( event ) {
				// parametry inputu
				var input = $( this );

				var min = parseFloat( input.data( 'min' ) );
				var max = parseFloat( input.data( 'max' ) );
				var stock = parseFloat( input.data( 'stock' ) );
				var decimals_max = parseInt( input.data( 'decimals' ) );
				var unit = input.data( 'unit' );

				// cislo
				var val = input.val();
				val = parseFloat( val.replace( ',', '.' ) );

				if ( event.type != 'blur' && ( event.which != 46 || $( this ).val().indexOf( '.' ) != -1 ) && ( event.which != 44 || $( this ).val().indexOf( ',' ) != -1 ) && ( event.which < 48 || event.which > 57 ) ) {
					event.preventDefault();
				} else {
					if ( event.type != 'keypress' ) {
						// pokud nezadal člověk číslo, tak to vyresime
						if ( isNaN( val ) ) {
							val = min;
						}

						// des.místa
						var decimals = val.countDecimals();

						if ( decimals > decimals_max ) {
							var set_num = val.toFixed( decimals_max );
							set_num = set_num + '';
							input.val( parseFloat( set_num ) );
							val = parseFloat( set_num );
						}

						// des.místa - aktualne skladem
						var decimals_stock = stock.countDecimals();

						if ( decimals_stock > decimals_max ) {
							var set_num = stock.toFixed( decimals_max );
							set_num = set_num + '';
							stock = parseFloat( set_num );
						}

						// zkontrolujeme, zdali muzeme zbozi pridat do kosiku
						if ( val > stock ) {
							input.parent().find( '.error' ).text( syo_lang.limits_max + ' ' + comma( stock ) + ' ' + unit ).show();
							input.val( comma( stock ) );
							return;
						}

						if ( max != 0 && val > max ) {
							input.parent().find( '.error' ).text( syo_lang.limits_max + ' ' + comma( max ) + ' ' + unit ).show();
							input.val( comma( max ) );
							return;
						}

						if ( val < min ) {
							input.parent().find( '.error' ).text( syo_lang.limits_min + ' ' + comma( min ) + ' ' + unit ).show();
							input.val( comma( min ) );
							return;
						}

						input.parent().find( '.error' ).hide();

						// nastavime hodnotu
						input.val( comma( val ) );
					}
				}
			} );

			$( this ).addClass( 'have-input-events' );
		}
	} );

	$( '.basket-form .count input' ).on( 'blur', function() {
		naja.uiHandler.submitForm( document.querySelector( '.basket-form' ) );
	} );

	$( '#minicart-form .count input' ).on( 'blur', function() {
		naja.uiHandler.submitForm( document.querySelector( '#minicart-form' ) );
	} );

	function autosizeAmountInput(el){
		const val = (el.value || '').trim();
		const base = 1; // malá rezerva
		el.style.width = Math.min(Math.max(val.length, 1) + base, 18) + 'ch';
	  }

	  // init po načtení
	  document.querySelectorAll('.ml-detail__amount input[name="amount"]').forEach(i=>{
		autosizeAmountInput(i);
		i.addEventListener('input', ()=>autosizeAmountInput(i));
	  });

	  // po kliknutí na +/- přepočítej po tom, co změníš hodnotu (jen detail produktu)
	  $(document).on('click', '.ml-detail__amount .minus, .ml-detail__amount .plus', function(){
		const el = $(this).closest('.count').find('input[name="amount"]')[0];
		if (el) autosizeAmountInput(el);
	  });
	  
	// Inputy pro přidávání do košíku
	// plus a minus
// Opakovací klik na podržení (+/-)
(function () {
	const HOLD_DELAY = 350;   // po kolika ms se z kliknutí stane „držení“
	const HOLD_INTERVAL = 80; // interval opakování během držení (ms)
  
	// Vytáhnuto z tvého click handleru: provede 1 krok +/-
	function applyStep($btn, dir) {
	  var input = $btn.closest('.count').find('input');
	  input.parent().find('.error').hide();
  
	  var min = parseFloat(input.data('min'));
	  var max = parseFloat(input.data('max'));
	  var step = parseFloat(input.data('step'));
	  var stock = parseFloat(input.data('stock'));
	  var decimals_max = parseInt(input.data('decimals'));
	  var unit = input.data('unit');
  
	  if (step == 0) step = 1;
  
	  var val = input.val();
	  val = parseFloat(String(val).replace(',', '.'));
  
	  var decimals = (typeof val.countDecimals === 'function')
		? val.countDecimals()
		: ((val.toString().split('.')[1] || '').length);
  
	  if (decimals > decimals_max) {
		var set_num = val.toFixed(decimals_max);
		input.val(parseFloat(set_num));
		val = parseFloat(set_num);
	  }
  
	  var new_value = (typeof fixFloat === 'function')
		? fixFloat(val + dir * step)
		: (val + dir * step);
  
	  var decimals_stock = (typeof stock.countDecimals === 'function')
		? stock.countDecimals()
		: ((stock.toString().split('.')[1] || '').length);
  
	  if (decimals_stock > decimals_max) {
		var set_num2 = stock.toFixed(decimals_max);
		stock = parseFloat(set_num2);
	  }
  
	  if (new_value > stock) {
		input.parent().find('.error').text(syo_lang.limits_max + ' ' + comma(stock) + ' ' + unit).show();
		input.val(comma(stock));
		submitIfNeeded(input);
		return;
	  }
  
	  if (max != 0 && new_value > max) {
		input.parent().find('.error').text(syo_lang.limits_max + ' ' + comma(max) + ' ' + unit).show();
		input.val(comma(max));
		submitIfNeeded(input);
		return;
	  }
  
	  if (new_value < min) {
		input.parent().find('.error').text(syo_lang.limits_min + ' ' + comma(min) + ' ' + unit).show();
		input.val(comma(min));
		submitIfNeeded(input);
		return;
	  }
  
	  input.val(comma(new_value));
	  submitIfNeeded(input);
	}
  
	function submitIfNeeded(input) {
	  if (input.parent().hasClass('count-minicart')) {
		naja.uiHandler.submitForm(document.querySelector('#minicart-form'));
	  } else if ($('.basket-form').length > 0) {
		naja.uiHandler.submitForm(document.querySelector('.basket-form'));
	  }
	}
  
	// Bind jen jednou na každé tlačítko
	$('.count .minus, .count .plus').each(function () {
	  var $btn = $(this);
	  if ($btn.hasClass('have-input-events')) return;
  
	  var dir = $btn.hasClass('minus') ? -1 : 1;
	  var holdTimeout = null;
	  var holdInterval = null;
	  var holding = false;
  
	  function stopHolding() {
		if (!holding) return;
		clearTimeout(holdTimeout); holdTimeout = null;
		clearInterval(holdInterval); holdInterval = null;
		holding = false;
		$(window).off('.holdstep');
	  }
  
	  // start držení (myš i dotyk)
	  $btn.on('mousedown.holdstep touchstart.holdstep', function (e) {
		e.preventDefault(); // žádné „select textu“ a zamezíme default klikům
		applyStep($btn, dir); // okamžitý 1 krok
  
		holding = true;
		holdTimeout = setTimeout(function () {
		  holdInterval = setInterval(function () {
			applyStep($btn, dir); // další kroky během držení
		  }, HOLD_INTERVAL);
		}, HOLD_DELAY);
  
		// ukončení držení kdekoliv
		$(window).on('mouseup.holdstep touchend.holdstep touchcancel.holdstep blur.holdstep', stopHolding);
	  });
  
	  // pro jistotu i při odjetí kurzoru z okna
	  $btn.on('mouseleave.holdstep', stopHolding);
  
	  $btn.addClass('have-input-events');
	});
  })();

  
	  

	// Quantityover
	$( '.quantityover ul li' ).on( 'click', function( e ) {
		if ( !$( this ).hasClass( 'have-input-events' ) ) {
			var amount = $( this ).data( 'amount' ) + '';

			if ( amount == 'redirect' ) {
				location.href = $( this ).data( 'href' );
			} else {
				$( this ).closest( '.listing__item' ).find( 'form.add-to-cart' ).find( 'input[name="amount"]' ).val( amount.replace( '.', ',' ) );
				$( this ).closest( '.listing__item' ).find( 'form.add-to-cart' ).find( 'button' ).click();
			}

			$( this ).addClass( 'have-input-events' );

			if ( typeof ga != 'undefined' ) {
				ga('send', 'event', 'product_list', 'shortcuts', amount );
			}
		}
	} );

	// Vyhledávací pole pro PRODUKTY
	$( '#product-search' ).on( 'keyup paste change', function( e ) {
		naja.uiHandler.submitForm( document.querySelector( '#product-search-form' ) );
	} );

	// Vyhledávač (našeptávač)
	var searchLog = null;
	var searchLogSaved = [];
	var submitMarketplaceControl = false;
	$( document ).on( 'keyup paste', '#header-search', function( e ) {
		if ($('#header-search').val().length > 3 && submitMarketplaceControl === false) {
			submitMarketplaceControl = true;
			naja.uiHandler.submitForm( document.querySelector( '#header-search-form' ) ).then((response) => {
				submitMarketplaceControl = false;
			})

			// zalogujeme hledani
			var v = $( this ).val();
			window.clearTimeout( searchLog );
			if ( v.length > 1 ) {
				if ( searchLogSaved.indexOf( v ) == -1 ) {
					searchLog = window.setTimeout( function() {
						searchLogSaved.push( v );
						$.post( global_search_log, { query: v } );
						$.get( global_search + '?query=' + v ); // prefetch
					}, 2200 );
				}
			}
			// END logovani hledani
		}
	});

	$( document ).on( 'keyup paste', '#header-search-marketplace', function( e ) {
		if ($('#header-search-marketplace').val().length > 3 && submitMarketplaceControl === false) {
			submitMarketplaceControl = true;
			naja.uiHandler.submitForm( document.querySelector( '#header-search-form' ) ).then((response) => {
				submitMarketplaceControl = false;
			})
		}
	});

	$( '#header-search-mobile' ).on( 'keyup paste', function( e ) {
		naja.uiHandler.submitForm( document.querySelector( '#header-search-form-mobile' ) );

		// zalogujeme hledani
		var v = $( this ).val();
		window.clearTimeout( searchLog );
		if ( v.length > 1 ) {
			if ( searchLogSaved.indexOf( v ) == -1 ) {
				searchLog = window.setTimeout( function() {
					searchLogSaved.push( v );
					$.post( global_search_log, { query: v } );
				}, 2200 );
			}
		}
		// END logovani hledani
	} );

	$( '#header-search-form, #header-search-form-mobile' ).on( 'submit', function( e ) {
		$( this ).attr( 'method', 'GET' ).attr( 'action', global_search );
	} );

	// Výběr varianty
	$( 'input[name="variant_id"], select[name="variant_id"]' ).on( 'change', function( e ) {
		if ( window.variant_type == 'radio' ) {
			var stock = $( this ).parent().parent().parent().find( 'input[type="radio"]' ).filter( ':checked' ).data( 'stock' );
			var stock2 = $( this ).parent().parent().parent().find( 'input[type="radio"]' ).filter( ':checked' ).data( 'stock2' );
			var own_code = $( this ).parent().parent().parent().find( 'input[type="radio"]' ).filter( ':checked' ).attr( 'data-own-code' );
			var price = $( this ).parent().parent().parent().find( 'input[type="radio"]' ).filter( ':checked' ).data( 'price' );
			var unit = $( this ).parent().parent().parent().find( 'input[type="radio"]' ).filter( ':checked' ).data( 'unit' );

			var min = $( this ).parent().parent().parent().find( 'input[type="radio"]' ).filter( ':checked' ).data( 'min' );
			var max = $( this ).parent().parent().parent().find( 'input[type="radio"]' ).filter( ':checked' ).data( 'max' );
			var step = $( this ).parent().parent().parent().find( 'input[type="radio"]' ).filter( ':checked' ).data( 'step' );
			var decimals = $( this ).parent().parent().parent().find( 'input[type="radio"]' ).filter( ':checked' ).data( 'decimals' );

			var vid = $( this ).parent().parent().parent().find( 'input[type="radio"]' ).filter( ':checked' ).data( 'id' );

		} else {
			var stock = $( this ).find( ':selected' ).data( 'stock' );
			var stock2 = $( this ).find( ':selected' ).data( 'stock2' );
			var stock3 = $( this ).find( ':selected' ).data( 'stock3' );
			var own_code = $( this ).find( ':selected' ).attr( 'data-own-code' );
			var price = $( this ).find( ':selected' ).data( 'price' );

			var min = $( this ).find( ':selected' ).data( 'min' );
			var max = $( this ).find( ':selected' ).data( 'max' );
			var step = $( this ).find( ':selected' ).data( 'step' );
			var decimals = $( this ).find( ':selected' ).data( 'decimals' );
			var unit = $( this ).find( ':selected' ).data( 'unit' );

			var vid = $( this ).find( ':selected' ).data( 'id' );
		}

		$( '.add-to-cart .price strong.main-price' ).html( price );
		$( '.stock-variants strong span' ).html( stock3 );

		if ( stock2 > 0 ) {
			$( '.on-branch' ).css( 'display', 'inline-block' ).attr( 'data-tip', 'Na prodejně v Brně máme ' + stock2 + ' ' + unit );
		} else {
			$( '.on-branch' ).hide();
		}

		$( '#own-code' ).html( own_code );
		$( '#own-code-2' ).html( own_code );

		$( '.add-to-cart' ).find( 'input[name="amount"]' ).data( 'min', min ).data( 'max', max ).data( 'step', step ).data( 'decimals', decimals ).data( 'stock', stock ).val( 1 );

		// GA4 view_item re-fire — jen při REÁLNÉ změně varianty uživatelem (e.originalEvent);
		// programový trigger('change') na load přeskočíme, ten už pokryl server-side view_item
		if ( e && e.originalEvent ) {
			var $ga4Sel = $( this ).is( 'select' ) ? $( this ).find( ':selected' ) : $( this );
			var ga4Price = ga4ParsePrice( $ga4Sel.attr( 'data-price-actualf' ) || $ga4Sel.data( 'price' ) || $( '.add-to-cart .price strong.main-price' ).text() );
			var ga4Vname = $.trim( $ga4Sel.text() || '' );
			if ( $( this ).val() ) ga4ViewItem( $( this ).val(), ga4Price, ga4Vname );
		}

		// obrázek varianty
		var variant_image = getSwiperIndexForVariant( vid );

		if ( variant_image !== false ) {
			// mobilní verze
			if ( typeof galleryMobileSwiper != 'undefined' ) {
				galleryMobileSwiper.slideTo( variant_image, 300 );
			}

			// nastavení srcsetů - desktop
			$( '.headimg_new' ).attr( 'data-num', variant_image );
			// jen zdroje s data-srcset-jpg (1. slide má navíc WebP <source> → jinak by se posunul index)
			var mobile_el = $( '#mobile-gallery-swiper .img-variant-helper picture source[data-srcset-jpg]' ).eq( variant_image );
			if ( typeof mlSetHeroSrcset === 'function' ) {
				mlSetHeroSrcset( mobile_el.attr( 'data-srcset-jpg' ), mobile_el.attr( 'data-srcset-webp' ) );
			} else {
				var im_srcset = document.querySelector( '#headimg_new_jpg' );
				if ( im_srcset ) im_srcset.srcset = mobile_el.attr( 'data-srcset-jpg' );
			}
		}
	} );

	if ( $( 'input[name="variant_id"], select[name="variant_id"]' ).length > 0 ) {
		$( 'input[name="variant_id"], select[name="variant_id"]' ).trigger( 'change' );
	}

	// Video v detailu produktu
	$( '.video' ).on( 'click', function( e ) {
		var url = $( '.video-container' ).data( 'url' );
		var iframe = '<iframe src="' + url + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
		$( '.video' ).hide();
		$( '.video-container' ).html( iframe ).show();
		e.preventDefault();
	} );
}

// Vyber dopravy
function deliveryChoose() {
	$( '.deliveryChoose' ).on( 'change', function( e ) {
		deliverySaving( true );
		naja.uiHandler.submitForm( document.querySelector( '#basket-delivery-form' ) );
		easyReturnToggle( this );
	} );

	$( 'input[name="pair_with_email"]' ).on( 'blur', function( e ) {
		naja.uiHandler.submitForm( document.querySelector( '#basket-delivery-form' ) );
	} );

	$( '#disable_pair_mail' ).on( 'click', function( e ) {
		$( 'input[name="pair_with_email"]' ).val( '' );
		naja.uiHandler.submitForm( document.querySelector( '#basket-delivery-form' ) );
		e.preventDefault();
	} );
}

// Jednoduché vrácení: přepínač karty přes naja — handle easyReturn! překreslí snippet
// basket-delivery (nový stav karty + rekapitulace). Delegovaně, karta žije ve snippetu.
$( document ).on( 'click', '.easy-return', function( e ) {
	e.preventDefault();

	var url = this.getAttribute( this.classList.contains( 'is-on' ) ? 'data-url-off' : 'data-url-on' );

	if ( !url ) {
		return;
	}

	if ( window.naja ) {
		deliverySaving( true );
		naja.makeRequest( 'GET', url, null, { history: false } );
	} else {
		window.location.href = url;
	}
} );

// Jednoduché vrácení / Expresní expedice: karty se ukazují jen u vhodných doprav (ID nese data-er-ids) —
// volba dopravy jde přes naja bez překreslení, viditlenost proto přepínáme tady pro VŠECHNY karty služeb
// (.easy-return sdílí i karta Expresní expedice, 18.10.2026)
function easyReturnToggle( radio ) {
	var cards = document.querySelectorAll( '.easy-return' );

	if ( !cards.length || !radio || !radio.value ) {
		return;
	}

	var delivery_id = String( radio.value ).split( ',' )[ 0 ];

	cards.forEach( function( card ) {
		var ids = ( card.getAttribute( 'data-er-ids' ) || '' ).split( ',' );
		card.style.display = ( ids.indexOf( delivery_id ) !== -1 ? '' : 'none' );
	} );
}

// Vyber platby
function payChoose() {
	$( '.payChoose' ).on( 'change', function( e ) {
		deliverySaving( true );
		naja.uiHandler.submitForm( document.querySelector( '#basket-delivery-form' ) );
	} );
}

// Vyber země
function countryChoose() {
	$( '.countryChoose' ).on( 'change', function( e ) {
		naja.uiHandler.submitForm( document.querySelector( '#basket-delivery-form' ) );
	} );
}

// Taška osobní odběr
function bagChoose() {
	$( '#check-bag' ).on( 'change', function( e ) {
		naja.uiHandler.submitForm( document.querySelector( '#basket-delivery-form' ) );
	} );
}

// Zasilkovna - načtení okna
function packetaEvents() {
	$( '.packeta-selector-open' ).on( 'click', function() {
		var country = $( this ).data( 'country' );

		openPacketaWidget( country );
	} );
}

// otevření widgetu s pojistkou: když CDN knihovna ještě není načtená (pomalá síť, blokátor), donačte se a otevře dodatečně
function openPacketaWidget( country ) {
	if ( typeof Packeta == 'undefined' ) {
		var lib = document.getElementById( 'packeta-library-fallback' );

		if ( !lib ) {
			lib = document.createElement( 'script' );
			lib.id = 'packeta-library-fallback';
			lib.src = 'https://widget.packeta.com/v6/www/js/library.js';
			lib.onload = function() { openPacketaWidget( country ); };
			document.head.appendChild( lib );
		} else {
			lib.addEventListener( 'load', function() { openPacketaWidget( country ); }, { once: true } );
		}

		return;
	}

	Packeta.Widget.pick( '61ca4c7a665028c1', function( response ) {
			if ( response != null ) {
				$( '.packeta-selector-branch-name' ).text( response.name );
				$( 'input[name="zasilkovna_id"]' ).val( response.id );
				// pobočka vybrána → schovat případnou chybu „nemáte vybranou pobočku", ať uživatele nemate
				$( '.delivery-error' ).text( '' ).hide();
				//$.post( '?do=savePacketa', { id: response.id, name: response.name } );

				naja.makeRequest( 'POST', '?do=savePacketa', {
					id: response.id,
					name: response.name
				}, {
					history: false
				} );
			}

		}, {
			language: ( country == 'cz' ? 'cs' : ( country == 'sk' ? 'sk' : 'en' ) ),
			country: country //,
			// livePickupPoint: true
	} );
}

// PPL - načtení okna
function pplEvents() {
	$( document ).on( 'click', '.ppl-selector-open', function( e ) {
		var country = $( this ).data( 'country' );

		// Get the modal elements
		var modalOverlay = document.querySelector(".ppl-modal-overlay");
		var modalBox = document.querySelector(".ppl-modal-box");
		var closeButton = document.querySelector("#ppl-close-modal-button");

		modalOverlay.style.display = "block";
		modalBox.style.display = "block";

		// Create a link element to load the main.css file
		var link = document.createElement("link");
		link.rel = "stylesheet";
		link.href = "https://www.ppl.cz/sources/map/main.css";

		// Create a script element to load the main.js file
		var script = document.createElement("script");
		script.src = "https://www.ppl.cz/sources/map/main.js";

		// Add the script+href link to the document head
		document.head.appendChild(link);
		document.head.appendChild(script);

		// When the user clicks the close button, hide the modal
		closeButton.addEventListener("click", function () {
			modalOverlay.style.display = "none";
			modalBox.style.display = "none";
		});

		e.preventDefault();
	} );

	// Vybraná pobočka
	document.addEventListener(
		"ppl-parcelshop-map", function( event ) {
			console.log( 'PPL event', event.detail);

			var name = event.detail.name + ' (' + event.detail.street + ', ' + event.detail.city + ')';

			$( '.ppl-selector-branch-name' ).text( name );
			$( 'input[name="zasilkovna_id"]' ).val( event.detail.code );
			// pobočka vybrána → schovat případnou chybu „nemáte vybranou pobočku"
			$( '.delivery-error' ).text( '' ).hide();

			var modalOverlay = document.querySelector(".ppl-modal-overlay");
			var modalBox = document.querySelector(".ppl-modal-box");
			modalOverlay.style.display = "none";
			modalBox.style.display = "none";

			naja.makeRequest( 'POST', '?do=savePpl', {
				id: event.detail.code,
				name: name
			}, {
				history: false
			} );
		}
	);
}

// GLS výdejní místa - modal s mapou ve vlastním iframe (postMessage; viz dokumentace Implementace_PSD)
var GLS_MAP_ORIGIN = 'https://maps.gls-czech.cz';

function glsEvents() {
	// modal musí sedět přímo pod <body> — uvnitř obsahu stránky ho stacking context rodičů
	// nechá překreslit sticky hlavičkou (z-index 99), na mobilu pak chybí horní kus mapy
	$( '.gls-modal-overlay, .gls-modal-box' ).appendTo( 'body' );

	// otevření modalu — delegovaně, odkaz je uvnitř snippetu a při překreslení by o listener přišel
	$( document ).on( 'click', '.gls-selector-open', function( e ) {
		var country = $( this ).data( 'country' ) || 'CZ';
		var lang = $( this ).data( 'lang' ) || 'cs';
		var src = GLS_MAP_ORIGIN + '/?find=1&ctrcode=' + encodeURIComponent( country ) + '&lng=' + encodeURIComponent( lang );
		var iframe = document.getElementById( 'gls-parcelshop-iframe' );

		// mapa se načítá až při prvním otevření; po změně země doručení se src přepíše
		if ( iframe && iframe.getAttribute( 'src' ) != src ) {
			iframe.setAttribute( 'src', src );
		}

		// display řídíme i inline (markup má style="display:none" jako pojistku proti staré CSS cache) —
		// samotné .active by inline styl nepřebilo
		$( '.gls-modal-overlay' ).addClass( 'active' ).css( 'display', 'block' );
		$( '.gls-modal-box' ).addClass( 'active' ).css( 'display', 'flex' );

		e.preventDefault();
	} );

	// zavření modalu (tlačítko Zavřít i klik do overlay)
	$( document ).on( 'click', '.js-gls-close', function( e ) {
		glsCloseModal();
		e.preventDefault();
	} );

	$( document ).on( 'keydown', function( e ) {
		if ( e.key == 'Escape' ) {
			glsCloseModal();
		}
	} );

	// výběr místa v mapě → mapa pošle postMessage s objektem parcelshop
	if ( !window.gls_message_bound ) {
		window.gls_message_bound = true;

		window.addEventListener( 'message', function( event ) {
			// bezpečnost: zprávy bereme výhradně z GLS mapy
			if ( event.origin != GLS_MAP_ORIGIN ) {
				return;
			}

			if ( !event.data ) {
				return;
			}

			// mapa umí poslat i požadavek na zavření (stejně ho obsluhuje oficiální GLS widget)
			if ( event.data.event_id == 'closeWidget' ) {
				glsCloseModal();
				return;
			}

			if ( !event.data.parcelshop || !event.data.parcelshop.detail ) {
				return;
			}

			var detail = event.data.parcelshop.detail;

			if ( !detail.pclshopid ) {
				return;
			}

			var name = ( detail.name || '' ) + ' (' + ( detail.address || '' ) + ', ' + ( detail.city || '' ) + ')';
			var cod = ( detail.iscodhandler === 't' ? 't' : 'f' );
			var ctr = ( detail.ctrcode ? String( detail.ctrcode ).toUpperCase() : '' );

			$( '.gls-selector-branch-name' ).text( name );
			// data-cod měníme přes attr() — validace ho přes attr() i čte (data() kešuje)
			$( 'input[name="gls_id"]' ).val( detail.pclshopid ).attr( 'data-cod', cod );

			glsCloseModal();

			// místo vybráno → schovat případnou chybu „nemáte vybrané místo"
			$( '.delivery-error' ).text( '' ).hide();

			// dobírka na místo, které ji nebere → říct hned, ne až u tlačítka Pokračovat
			if ( cod == 'f' && $( 'input[name="pay"]:checked' ).data( 'paytype' ) == 'cod' ) {
				$( '.delivery-error' ).text( syo_lang.gls_no_cod ).show();
			}

			naja.makeRequest( 'POST', '?do=saveGls', {
				id: detail.pclshopid,
				name: name,
				cod: cod,
				ctr: ctr
			}, {
				history: false
			} );
		} );
	}
}

function glsCloseModal() {
	$( '.gls-modal-overlay, .gls-modal-box' ).removeClass( 'active' ).css( 'display', 'none' );

	// zavření si pamatujeme: auto-otevření mapy (skript ve snippetu dopravy) se spouští při KAŽDÉM
	// překreslení snippetu (změna platby atd.) — bez flagu by se mapa otevírala pořád dokola
	// a nešlo zvolit jinou dopravu; ruční otevření odkazem funguje vždy
	window.gls_map_dismissed = true;
}

// Má člověk toto zboží v košíku?
function in_basket( product_id ) {
	var found = window.basket_items.filter( function( item ) {
		return item.product_id == product_id
	} );

	if ( found.length > 0 ) {
		$( '.in_basket_' + product_id ).html( window.lang_in_basket_have + ' <strong>' + comma( found[0]['amount'] ) + ' ' + found[0]['unit'] + '</strong> ' + window.lang_in_basket_have_for + ' <strong>' + found[0]['price_formatted'] + '</strong>' ).show();
	}
}

// Štítky „V košíku máte…" na všech kartách najednou (26.9.2026): dřív měla každá karta vlastní inline
// <script>in_basket(id)</script> (96+ skriptů na výpis). Položek v košíku je málo → projdeme je a vyplníme
// odpovídající .in_basket_{id}. Volá se po načtení, po každém Naja překreslení (načíst další) a po AJAX blocích.
function in_basket_all() {
	if ( typeof window.basket_items === 'undefined' || !window.basket_items || !window.basket_items.length ) return;
	for ( var i = 0; i < window.basket_items.length; i++ ) {
		in_basket( window.basket_items[i].product_id );
	}
}
window.in_basket_all = in_basket_all;
$( function() { in_basket_all(); } );
naja.addEventListener( 'complete', function() { in_basket_all(); } );

// Minicart - mobile
function minicartMobile() {
	var price = $( '.minicart-price' ).first().html();
	var amount = parseInt( $( '#minicart-amount-1' ).first().text() );

	if ( amount > 0 ) {
		$( '#mobile-minicart' ).addClass( 'active' );
		$( '#mobile-minicart-amount' ).text( amount );
		$( '#mobile-minicart-price' ).html( price );
	}
}

// Aktualizace položek minikošíku
function minicart_update() {
	$( '#minicart-items table' ).html( '' );

	for ( var i = 0; i < window.basket_items.length; i++ ) {
		var item = window.basket_items[i];

		var amount = '' + item.amount;

		var html = '<tr>';
		html += '<th colspan="3">';
		html += '<a href="' + item.url + '">' + item.name + '</a>';
		html += '</th></tr>';

		html += '<tr>';
		html += '<td><a class="img" href="' + item.url + '" style="background-image: url(\'' + item.image + '\');"></td>';
		html += '<td>';
		html += '	<span class="count count-minicart">';
		html += '		<input name="amount[' + item.product_id + ']" type="text" value="' + amount.replace( '.', ',' ) + '" data-min="' + item.min + '" data-max="' + item.max + '" data-step="' + item.step + '" data-stock="' + item.stock + '" data-decimals="' + item.decimals + '" data-unit="' + item.unit + '">';
		html += '		<span class="minus"></span>';
		html += '		<span class="plus"></span>';
		html += '		<span class="alert error" style="display: none; top: 44px; left: -40px;"></span>';
		html += '	</span>';
		html += '	<em>' + item.unit + '</em>';
		html += '</td>';
		html += '<td><strong class="pink">' + item.price_formatted + '</strong></td>';
		html += '</tr>';

		$( '#minicart-items table' ).append( html );
	}

	$( '#minicart-items' ).removeClass( 'hidden' );

	inputEvents();
}

// Zobrazíme fixovaný košík?
function fixedcart() {
	if ( $( '#snippet--basket-total' ).length > 0 ) {
		var btn_offset = $( '#snippet--basket-total' ).offset().top;
		var window_height = $( window ).height();

		if ( window_height < btn_offset ) {
			$( '.fixedcart' ).removeClass( 'hidden' );
		}
	}
}

// Změna URL bez obnovení
function changeUrl( urlPath, title, html ) {
	window.history.pushState( { "html": html, "pageTitle": title }, "", urlPath );
}

// Pomocné funkce
Number.prototype.countDecimals = function () {
	if(Math.floor(this.valueOf()) === this.valueOf()) return 0;
	return this.toString().split(".")[1].length || 0;
}

function fixFloat( num ) {
	return ( Math.round( parseFloat( num ) * 100 ) / 100 );
}

function comma( num ) {
	return num.toString().replace( '.', ',' );
}

function radioFix() {
	$('.radio').click(function(e) {
		if ( e.target.className != 'packeta-selector-open' && e.target.className != 'ppl-selector-open' && e.target.className != 'gls-selector-open' && e.target.className != 'login-link' && (typeof e.currentTarget != 'undefined' && !$( e.currentTarget ).hasClass('pair-disabled') ) ) {
			var radioid = $(this).attr('for'),
			radioname = $('#'+radioid).attr('name');
			$('input[name="'+radioname+'"]').removeAttr('checked');
			$('#'+radioid).attr("checked", "checked").trigger('change');

			checkradio();
		}

		if ( $( e.currentTarget ).hasClass('pair-disabled') && e.target.className != 'login-link'  ) {
			e.preventDefault();
		}
	});
}

// Novinky a akce - aktivní efekt
function newsAndSaleActive() {
	window.setTimeout( function() {
		$( '.ic_news, .ic_sale' ).removeClass( 'underlined' );
		$( '.list-link-sale, .list-link-news' ).removeClass( 'active' );

		if ( location.href.indexOf( 'sort=news' ) > -1 ) {
			$( '.ic_news' ).addClass( 'underlined' );
			$( '.list-link-news' ).addClass( 'active' );
		}

		if ( location.href.indexOf( 'sort=sale' ) > -1 ) {
			$( '.ic_sale' ).addClass( 'underlined' );
			$( '.list-link-sale' ).addClass( 'active' );
		}
	}, 50 );
}

// Shake efekt
jQuery.fn.shake = function(interval,distance,times){
	interval = typeof interval == "undefined" ? 100 : interval;
	distance = typeof distance == "undefined" ? 10 : distance;
	times = typeof times == "undefined" ? 3 : times;
	var jTarget = $(this);
	jTarget.css('position','relative');
	for(var iter=0;iter<(times+1);iter++){
	  jTarget.animate({ left: ((iter%2==0 ? distance : distance*-1))}, interval);
	}
	return jTarget.animate({ left: 0},interval);
}

// Shake efekt
jQuery.fn.shake2 = function(interval,distance,times,whatcss){
	interval = typeof interval == "undefined" ? 100 : interval;
	distance = typeof distance == "undefined" ? 10 : distance;
	times = typeof times == "undefined" ? 3 : times;
	whatcss = typeof whatcss == "undefined" ? 'margin-left' : whatcss;
	var jTarget = $(this);
	for(var iter=0;iter<(times+1);iter++){
		if ( whatcss == 'margin-top' ) {
	  		jTarget.animate({ 'margin-top': ((iter%2==0 ? distance : distance*-1))}, interval);
		} else if ( whatcss == 'margin-left' ) {
			jTarget.animate({ 'margin-left': ((iter%2==0 ? distance : distance*-1))}, interval);
		}
	}

	if ( whatcss == 'margin-top' ) {
		return jTarget.animate({ 'margin-top': 0},interval);
	} else if ( whatcss == 'margin-left' ) {
		return jTarget.animate({ 'margin-left': 0},interval);
	}
}

// Zvolení první platební metody z nabízených
function chooseFirstPayMethod() {
	$( '.payChoose' ).first().parent().parent().find( 'label' ).click();
}

// Preload obrázků
window.images_preload = [];
function preload() {
	for ( var i = 0; i < arguments.length; i++ ) {
		var img = new Image();
		img.src = preload.arguments[i];
		window.images_preload.push( img );
	}
}

// Mobilní řazení
function mobileSort() {
	$( '.mobile-sorting a' ).on( 'click', function( e ) {
		$( '#snippet--products' ).removeAttr( 'data-naja-snippet-append' );

		$.LoadingOverlay( 'show' );

		naja.makeRequest( 'GET', $( this ).attr( 'href' ) )
			.then( function( response ) {
				if ( typeof response.snippets != 'undefined' ) {
					$( '#snippet--products' ).attr( 'data-naja-snippet-append', 'true' );
					$.LoadingOverlay( 'hide' );
				}
			})
			.catch( function( error ) {
				$( '#snippet--products' ).attr( 'data-naja-snippet-append', 'true' );
				$.LoadingOverlay( 'hide' );
			});

		e.preventDefault();
	} );
}

$( document ).on( 'click', '.landing-ajax', function( e ) {
	$( '#snippet--products' ).attr( 'data-naja-snippet-append', 'true' );

	naja.makeRequest( 'GET', $( this ).attr( 'href' ) )
		.then( function( response ) {
			if ( typeof response.snippets != 'undefined' ) {
				$( '#snippet--products' ).removeAttr( 'data-naja-snippet-append' );
				$.LoadingOverlay( 'hide' );
			}
		})
		.catch( function( error ) {
			$( '#snippet--products' ).removeAttr( 'data-naja-snippet-append' );
		});

	e.preventDefault();
} );

// Klikací řádek tabulky
function clickableRow() {
	$( '.clickable-row td' ).on( 'click', function( e ) {
		location.href = $( this ).parent().data( 'href' );
		e.preventDefault();
	} );
}

// Klikací řádek tabulky - vyvolá event pro použití v různých scriptech
function productsClickableRow() {
	$( '.products-clickable-row td' ).on( 'click', function( e ) {
		var product_id = $( this ).parent().data( 'product' );
		$( window ).trigger( 'product-search', [ product_id ] );
		e.preventDefault();
	} );
}

// Přidání do oblíbených
function addToFavoritesHandler() {
	$( '.favorites-handler:not(.have-events)' ).each( function() {
		if ( $( this ).data( 'action' ) == 'remove' ) {
			var action = 'removeFromFavorites';
		} else {
			var action = 'addToFavorites';
		}

		$( this ).attr( 'href', '?favorites-type=' + $( this ).data( 'type' ) + '&favorites-product_id=' + $( this ).data( 'id' ) + '&do=favorites-' + action );
	} );
}


function isElementInViewport (el) {

    var rect = el.getBoundingClientRect();
	var fix = $('.fix').outerHeight()+50;
	var maxtop = ($(window).height()-fix)*0.5+fix;

    return (
        rect.bottom >= fix &&
        rect.top <= maxtop
    );
}

function onVisibilityChange(el, callback) {
    var old_visible;
    return function () {
        var visible = isElementInViewport(el);
        if (visible != old_visible) {
            old_visible = visible;
            if (typeof callback == 'function') {
                callback(visible);
            }
        }
    }
}

// BUY MORE - motivační nástroj
function buyMore() {
	if ( $( '#buy-more' ).length > 0 ) {
		window.setInterval( function() {
			buy_more_runner();
		}, 300 );
	}
}

function buy_more_runner() {
	var set_null = true;
	if ( typeof window.basket_items != 'undefined' && window.basket_items.length > 0 ) {
		var product_id = $( '#buy-more' ).data( 'id' );
		for ( var i = 0; i < window.basket_items.length; i++ ) {
			if ( window.basket_items[i].product_id == product_id ) {
				var in_basket = window.basket_items[i].amount;
				if ( in_basket > 5 ) {
					in_basket = 5;
				}

				var is_mobile = ( $( '#buy-more-hidden' ).css( 'display' ) == 'none' ? true : false );

				var percent = in_basket * ( is_mobile ? 33.333 : 20 );
				$( '#buy-more-status' ).attr( 'style', '--loaded:' +  percent + '%' );

				set_null = false;
			}
		}

		if ( set_null ) {
			$( '#buy-more-status' ).attr( 'style', '--loaded: 0%' );
		}
	}
}

/**
 * Cookie box
 */
function cookiesBox() {
	$( ".js-modal__accordion-button" ).click(function () {
		$( this ).toggleClass( "modal__accordion-button--active" );
		$( this ).parent( '.modal__accordion-heading' ).next( '.modal__accordion-collapse' ).slideToggle();
	});

	$( '.cookies-switch' ).on( 'click', function( e ) {
		$( '.cookies-1' ).hide();
		$( 'div.cookies-2' ).show();
		$( 'footer.cookies-2' ).css( 'display', 'flex' );
		e.preventDefault();
	} );

	$( '.cookies-allow-all' ).click( function( e ) {
		Cookies.set( 'cookies', 'all', { expires: 365, path: '/' } );
		$.post( '/cookies-stats', { choices: 'all' } );
		location.reload();
		e.preventDefault();
	} );

	$( '.cookies-allow-something' ).click( function( e ) {
		var allowed = [];
		allowed.push( 'basic' );

		if ( $( '#switch--2' ).prop( 'checked' ) ) {
			allowed.push( 'preferences')
		}

		if ( $( '#switch--3' ).prop( 'checked' ) ) {
			allowed.push( 'analytics')
		}

		if ( $( '#switch--4' ).prop( 'checked' ) ) {
			allowed.push( 'marketing')
		}

		Cookies.set( 'cookies', allowed.join( ',' ), { expires: 365, path: '/' } );

		$.post( '/cookies-stats', { choices: allowed.join( ',' ) } );

		location.reload();
		e.preventDefault();
	} );
}

/**
 * Zákaz scrollování u input type number
 */
function noNumberScroll() {
	document.addEventListener("wheel", function(event){
		if(document.activeElement.type === "number" &&
		   document.activeElement.classList.contains("no-arrows"))
		{
			document.activeElement.blur();
		}
	});
}

/**
 * Odpočty
 */
function cupon_countdown( target ) {

	var ted = new Date().getTime() / 1000;
	var diff = target - ted;

	if ( diff <= 0 ) {
		$( '#use-cupon' ).hide();
		return;
	}

	var tmp = diff;
	var d = Math.floor( tmp / 86400 );
	tmp = tmp % 86400;
	var h = Math.floor( tmp / 3600 );
	tmp = tmp % 3600;
	var m = Math.floor( tmp / 60 );
	tmp = tmp % 60;
	var s = Math.floor(tmp);

	if ( $( '#odp-d' ).length > 0 ) {
		$( '#odp-d' ).html( ( d < 10 ? '0' + d : d ) );
	}

	$( '#odp-h' ).html( ( h < 10 ? '0' + h : h ) );
	$( '#odp-m' ).html( ( m < 10 ? '0' + m : m ) );
	$( '#odp-s' ).html( ( s < 10 ? '0' + s : s ) );

	window.setTimeout( function() {
		cupon_countdown( target );
	}, 1000 );
}

function header_strip_countdown( target ) {

	var ted = new Date().getTime() / 1000;
	var diff = target - ted;
	var tmp = diff;
	var d = Math.floor( tmp / 86400 );
	tmp = tmp % 86400;
	var h = Math.floor( tmp / 3600 );
	tmp = tmp % 3600;
	var m = Math.floor( tmp / 60 );
	tmp = tmp % 60;
	var s = Math.floor(tmp);

	var timer = '';

	if ( d == 0 ) {

	} else if ( d == 1 ) {
		timer += ( d < 10 ? '0' + d : d ) + ' den, ';
	}
	else if ( d == 2 || d == 3 || d == 4 )
	{
		timer += ( d < 10 ? '0' + d : d ) + ' dny, ';
	}
	else
	{
		timer += ( d < 10 ? '0' + d : d ) + ' dní, ';
	}

	timer += ( h < 10 ? '0' + h : h ) + ':';
	timer += ( m < 10 ? '0' + m : m ) + ':';
	timer += ( s < 10 ? '0' + s : s );

	$( '.automaticTimer' ).html( timer );

	window.setTimeout( function() {
		header_strip_countdown( target );
	}, 1000 );
}

/**
 * Zjistí ID položky ve swiperu dle čísla varianty
 */
function getSwiperIndexForVariant( variant_id ) {
	var found = false;
	var i = 0;

	$( '.img-variant-helper' ).each( function() {
		if (  $( this ).data( 'variant' ) == variant_id ) {
			found = i;
		}

		i++;
	} );

	return found;
}

function showProductModal( product_id ) {
	$.get( '/product-modal?product_id=' + product_id, function( data ) {

		$( '#addedToCartProducts' ).html( data );
		in_basket_all();

		// GA4 view_item_list – měření, že se upsell („Skvěle se k tomu hodí") zobrazil; produkty čteme z vloženého HTML
		if ( typeof gtag != 'undefined' ) {
			var upItems = [];
			$( '#addedToCartProducts [data-id]' ).each( function( i ) {
				var $p = $( this );
				var nm = $p.find( 'h3' ).first().text().trim();
				var pr = parseFloat( ( $p.find( '.price strong' ).first().text() || '' ).replace( /[^0-9,.]/g, '' ).replace( ',', '.' ) );
				if ( $p.data( 'id' ) ) upItems.push( { item_id: String( $p.data( 'id' ) ), item_name: nm, price: isNaN( pr ) ? undefined : pr, index: i, item_list_name: 'cart_upsell', item_list_id: 'cart_upsell' } );
			} );
			if ( upItems.length ) gtag( 'event', 'view_item_list', { item_list_name: 'cart_upsell', item_list_id: 'cart_upsell', items: upItems } );
		}

		window.setTimeout( function() {
			inputEvents();
			addToCartEvents();
			addToFavoritesHandler();
		}, 200 );
	});
}

/**
 * Výběr dárku v košíku
 */
$( document ).on( 'change', '.basket-gift', function( e ) {
	naja.makeRequest( 'POST', '?do=changeGift', JSON.stringify( { gift_id: $( this ).val() } ), {
		fetch: {
			headers: {
				'Content-Type': 'application/json',
			},
		},
	} );
} );

/**
 * Show more text
 */
$( document ).on( 'click', '.show-more', function( e ) {
	var el = $( this ).parent().find( '.shorter-text' );
	el.addClass( 'expanded' );
	$( this ).hide();
	e.preventDefault();
});

// modal with confirmation
function showModalWithConfirmation(rel, link) {
	let xhr = new XMLHttpRequest();

	xhr.onload = function (e) {
		if (xhr.status === 200) {
			let res = JSON.parse(xhr.response);
			if (res.link !== undefined) {
				window.location.href = 'https://' + window.location.hostname + res.link;
				$.LoadingOverlay( 'hide' );
			} else if(res.validation) {
				$('.' + rel).addClass('opened');
				$('.' + rel).find('#frm-confirmationForm').find('input[name="id"]').val(res.accessId);
				window.setTimeout( function() {
					$( 'input[name="code"]' ).focus();
				}, 300 );
				$.LoadingOverlay( 'hide' );
			}
		}
	}

	console.log( "Spoustim request" );
	xhr.open("POST", link, true);
	xhr.setRequestHeader('Content-type', 'application/json');
	xhr.send();
}

function countdown( elementName, minutes, seconds )
{
    var element, endTime, hours, mins, msLeft, time;

    function twoDigits( n )
    {
        return (n <= 9 ? "0" + n : n);
    }

    function updateTimer()
    {
        msLeft = endTime - (+new Date);
        if ( msLeft < 1000 ) {
            element.innerHTML = "Nechte si zaslat nový kód.";
        } else {
            time = new Date( msLeft );
            hours = time.getUTCHours();
            mins = time.getUTCMinutes();
            element.innerHTML = (hours ? hours + ':' + twoDigits( mins ) : mins) + ':' + twoDigits( time.getUTCSeconds() );
            setTimeout( updateTimer, time.getUTCMilliseconds() + 500 );
        }
    }

    let preElement = document.getElementById( elementName );
	let p = document.createElement('p');
	element = preElement.appendChild(p);
    endTime = (+new Date) + 1000 * (60*minutes + seconds) + 500;
    updateTimer();
}

function digitalDownloadInit() {
	$(document).on('click', '[id^="open-"]', function() {
		let open = $(this).attr('data-open');
		let id = $(this).attr('id').split('-');
		if (open === '0') {
			$('.'+id[1]).show();
			$(this).attr('data-open', 1);
			$(this).find('.open').css('display', 'none');
			$(this).find('.collapsed').css('display', 'block');
		} else {
			$('.'+id[1]).hide();
			$(this).attr('data-open', 0)
			$(this).find('.open').css('display', 'block');
			$(this).find('.collapsed').css('display', 'none');
		}
	});

	$(document).on('click', '.openModalConfirm', function() {
		$.LoadingOverlay( 'show' );
		let link = $(this).attr('data-link');
		let rel = $(this).attr('rel');
		showModalWithConfirmation(rel, link);
		countdown( "ten-countdown", 10, 0 );
		$("#frm-confirmationForm-code_message").html("");
	});

	$(document).on('click', '.ic_close', function() {
		$('.confirm_layer').find('#ten-countdown').find('p').remove();
		$(".alert.error").remove();
		$("#frm-confirmationForm-code").val("");
		$("#frm-confirmationForm-code_message").html("");
	});

	$('body').on('click', function(e) {
		if($(e.target).closest('.confirm_layer').length == 0) {
			$('.confirm_layer').find('#ten-countdown').find('p').remove();
			$(".alert.error").remove();
			$("#frm-confirmationForm-code").val("");
			$("#frm-confirmationForm-code_message").html("");
		}
	});

	naja.redirectHandler.addEventListener('redirect', (event) => {
		$('.confirm_layer').removeClass('opened');
		$('.openModalConfirm').css("pointer-events", "auto");
		$('.openModalConfirm').css("cursor", "pointer");
		$('.confirm_layer').find('.ten-countdown').find('p').remove();
		event.detail.setHardRedirect(true);
	});
}

function validateCode() {
	$('#frm-confirmationForm-code').on('keydown', function(e){
		let val = $(this).val();
		$(this).val(val.replace(/[^0-9]/g, ''));
		if ($(this).val().length > 3) {
			$(this).val($(this).val().substring(0,3));
		}
	});
}

function targitoBasket()
{
	if ( typeof Targito != 'undefined' )
	{
		$.post( '/targito-basket', {} ).done( function( data )
		{
			console.log( 'Targito basket', data.data );
			Targito.push('property', 'cart', data.data );
		});
	}
}

function creditCurrency()
{
	$( document ).on( 'change paste keyup', '#frm-buyCreditForm-amount', function( e ) {
		var currency = window.creditCurrencyInfo;
		var amount = parseInt( $( this ).val() );
		var price = ( amount / currency['rate'] ).toFixed( 2 );
		$( '#credit-price' ).html( price + ' ' + currency['name'] );
	});

	$( '#frm-buyCreditForm-amount' ).trigger( 'change' );
}

/* ml-accordion (FAQ, Základní popis) — delegovaně, funguje i na střihách bez description.latte */
$(document).on('click', '.js-ml-accordion__toggler', function () {
	var $toggler = $(this);
	var $collapse = $toggler.next('.js-ml-accordion__collapse');
	$toggler.toggleClass('active');
	if ($toggler.hasClass('active')) {
		$collapse.slideDown();
	} else {
		$collapse.slideUp();
	}
});


// Rychlý výběr nití: záložky řad (rodičovská kategorie Nitě) – přepíná viditelnou mřížku, formulář je společný
$( document ).on( 'click', '.js-tq-tab', function() {
	var $form = $( this ).closest( 'form' ), g = String( $( this ).data( 'group' ) );
	$form.find( '.js-tq-tab' ).removeClass( 'is-active' ).attr( 'aria-selected', 'false' );
	$( this ).addClass( 'is-active' ).attr( 'aria-selected', 'true' );
	$form.find( '.js-tq-grid' ).each( function() { $( this ).toggleClass( 'is-hidden', String( $( this ).data( 'group' ) ) !== g ); } );
} );
// na mobilu výběr sbalený (rozbalený by odsunul produkty o celou obrazovku); desktop zůstává open ze šablony
$( function() { if ( window.innerWidth < 768 ) { $( '.thread-quick[open]' ).removeAttr( 'open' ); } } );

// Hromadný výběr (délky zipu, nitě): +/− u pole .js-multi-qty v rámci řádku .js-multi-row; souhrn .js-multi-summary
$( document ).on( 'click', '.js-multi-step', function( e ) {
	e.preventDefault();
	// nitě: řádek (barva) má dvě počítadla (1 ks / balení) → input hledat v nejbližší nabídce .js-multi-offer, jinak v řádku
	var $row = $( this ).closest( '.js-multi-offer, .js-multi-row' );
	var $in = $row.find( '.js-multi-qty' ).first();
	var max = parseFloat( $in.attr( 'max' ) ) || 999;
	var v = ( parseInt( $in.val(), 10 ) || 0 ) + ( $( this ).data( 'step' ) > 0 ? 1 : -1 );
	$in.val( Math.max( 0, Math.min( max, v ) ) ).trigger( 'change' );
} );
$( document ).on( 'change input', '.js-multi-qty', function() {
	var $form = $( this ).closest( 'form' );
	var n = 0;
	$form.find( '.js-multi-qty' ).each( function() {
		var max = parseFloat( $( this ).attr( 'max' ) ) || 999;
		// data-decimal (dotisk: metráž po 0,5 m) = desetinná hodnota; zipy/nitě zůstávají celé kusy
		var raw = String( $( this ).val() ).replace( ',', '.' );
		var q = Math.max( 0, Math.min( max, ( $( this ).data( 'decimal' ) ? parseFloat( raw ) : parseInt( raw, 10 ) ) || 0 ) );
		// přepsat jen když se hodnota opravdu změnila (ořez na max / nečíslo) – „0,5" s čárkou zůstane, jak ji zákazník vidí
		if ( q !== ( parseFloat( raw ) || 0 ) ) $( this ).val( q );
		$( this ).closest( '.js-multi-offer, .js-multi-row' ).toggleClass( 'is-picked', q > 0 );
		n += q;
	} );
	var $sum = $form.find( '.js-multi-summary' );
	if ( $sum.length ) {
		$sum.find( '.js-multi-count' ).text( n );
		$sum.toggleClass( 'is-empty', n === 0 );
	}
} );
